import { Component, ChangeDetectionStrategy, ViewEncapsulation, Pipe, Injectable, ɵɵdefineInjectable, ɵɵinject, ChangeDetectorRef, Input, ElementRef, EventEmitter, Output, NgModule } from '@angular/core';
import { HttpHeaders, HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { __awaiter } from 'tslib';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/models.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function AccessToken() { }
if (false) {
    /** @type {?} */
    AccessToken.prototype.id;
    /** @type {?} */
    AccessToken.prototype.dateCreate;
    /** @type {?} */
    AccessToken.prototype.dateExpire;
    /** @type {?} */
    AccessToken.prototype.personId;
    /** @type {?} */
    AccessToken.prototype.token;
}
/** @enum {string} */
const ButtonIcons = {
    ADD: "add",
    ARROW_LEFT: "keyboard_arrow_right",
};
/**
 * @record
 */
function Customer() { }
if (false) {
    /** @type {?} */
    Customer.prototype.id;
    /** @type {?} */
    Customer.prototype.company;
    /** @type {?} */
    Customer.prototype.website;
    /** @type {?} */
    Customer.prototype.contactPerson;
    /** @type {?} */
    Customer.prototype.contactPersonEmail;
}
/**
 * @record
 */
function NavItem() { }
if (false) {
    /** @type {?} */
    NavItem.prototype.text;
    /** @type {?} */
    NavItem.prototype.link;
    /** @type {?|undefined} */
    NavItem.prototype.active;
    /** @type {?|undefined} */
    NavItem.prototype.child;
    /** @type {?|undefined} */
    NavItem.prototype.superUserOnly;
}
/**
 * @record
 */
function Person() { }
if (false) {
    /** @type {?} */
    Person.prototype.id;
    /** @type {?} */
    Person.prototype.role;
    /** @type {?} */
    Person.prototype.firstName;
    /** @type {?} */
    Person.prototype.lastName;
    /** @type {?} */
    Person.prototype.pseudo;
    /** @type {?} */
    Person.prototype.email;
    /** @type {?} */
    Person.prototype.password;
    /** @type {?} */
    Person.prototype.avatar;
    /** @type {?} */
    Person.prototype.dateCreate;
    /** @type {?} */
    Person.prototype.dateUpdate;
    /** @type {?} */
    Person.prototype.dateDelete;
    /** @type {?} */
    Person.prototype.dateLastConnection;
    /** @type {?} */
    Person.prototype.blockedAt;
    /** @type {?} */
    Person.prototype.blockedBy;
}
/**
 * @record
 */
function PersonRole() { }
if (false) {
    /** @type {?} */
    PersonRole.prototype.id;
    /** @type {?} */
    PersonRole.prototype.name;
}
/**
 * @record
 */
function Project() { }
if (false) {
    /** @type {?} */
    Project.prototype.id;
    /** @type {?} */
    Project.prototype.customerId;
    /** @type {?} */
    Project.prototype.name;
    /** @type {?} */
    Project.prototype.nameShort;
    /** @type {?} */
    Project.prototype.active;
}
/**
 * @record
 */
function ChartDonut() { }
if (false) {
    /** @type {?} */
    ChartDonut.prototype.label;
    /** @type {?} */
    ChartDonut.prototype.value;
    /** @type {?} */
    ChartDonut.prototype.info;
}
/**
 * @record
 */
function ChartLine() { }
if (false) {
    /** @type {?} */
    ChartLine.prototype.label;
    /** @type {?} */
    ChartLine.prototype.value;
    /** @type {?|undefined} */
    ChartLine.prototype.comparativeValue;
}
class Color {
    /**
     * @return {?}
     */
    static getList() {
        return [
            '#e64c65',
            '#11a8ab',
            '#fcb150',
            '#4fc4f6',
            '#F46FDA',
            'Blue',
            'BlueViolet',
            'Brown',
            'BurlyWood',
            'CadetBlue',
            'Chocolate',
            'Coral',
            'CornflowerBlue',
            'Crimson',
            'DarkBlue',
            'DarkCyan',
            'DarkGoldenRod',
            'DarkGreen',
            'DarkKhaki',
            'DarkMagenta',
            'DarkOliveGreen',
            'DarkOrange',
            'DarkOrchid',
            'DarkRed',
            'DarkSalmon',
            'DarkSeaGreen',
            'DarkSlateBlue',
            'DarkSlateGray',
            'DarkSlateGrey',
            'DarkTurquoise',
            'DarkViolet',
            'DeepPink',
            'DeepSkyBlue',
            'DimGray',
            'DimGrey',
            'DodgerBlue',
            'FireBrick',
            'ForestGreen',
            'Fuchsia',
            'Gold',
            'GoldenRod',
            'Green',
            'GreenYellow',
            'HotPink',
            'IndianRed',
            'Indigo',
            'Khaki',
            'LawnGreen',
            'LightBlue',
            'LightCoral',
            'LightGreen',
            'LightPink',
            'LightSalmon',
            'LightSeaGreen',
            'LightSkyBlue',
            'LightSteelBlue',
            'Lime',
            'LimeGreen',
            'Magenta',
            'Maroon',
            'MediumAquaMarine',
            'MediumBlue',
            'MediumOrchid',
            'MediumPurple',
            'MediumSeaGreen',
            'MediumSlateBlue',
            'MediumSpringGreen',
            'MediumTurquoise',
            'MediumVioletRed',
            'MidnightBlue',
            'MistyRose',
            'Moccasin',
            'Navy',
            'Olive',
            'OliveDrab',
            'Orange',
            'OrangeRed',
            'Orchid',
            'PaleGoldenRod',
            'PaleGreen',
            'PaleTurquoise',
            'PaleVioletRed',
            'PeachPuff',
            'Peru',
            'Pink',
            'Plum',
            'PowderBlue',
            'Purple',
            'RebeccaPurple',
            'Red',
            'RosyBrown',
            'RoyalBlue',
            'SaddleBrown',
            'Salmon',
            'SandyBrown',
            'SeaGreen',
            'Sienna',
            'SkyBlue',
            'SlateBlue',
            'SpringGreen',
            'SteelBlue',
            'Tan',
            'Teal',
            'Thistle',
            'Tomato',
            'Turquoise',
            'Violet',
            'Wheat',
            'YellowGreen'
        ];
    }
}
/** @type {?} */
const VPS_URI = 'https://api.server.prod.sleeksys.com';
/** @type {?} */
const VPS_TEST_URI = 'https://api.server.test.sleeksys.com';
/** @type {?} */
const API_URL_GCP = 'https://api.cloud.gcp.prod.sleeksys.com';
/** @type {?} */
const API_URL_AWS = 'https://api.cloud.aws.prod.sleeksys.com';
/** @type {?} */
const APP_URL_TEAM = API_URL_GCP + '/sleek-team';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/root/root.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RootComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
RootComponent.decorators = [
    { type: Component, args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                selector: 'sleek-commons-root',
                template: "<div class=\"container\">\n  <sleek-commons-header></sleek-commons-header>\n\n  <router-outlet></router-outlet>\n\n  <sleek-commons-footer></sleek-commons-footer>\n</div>\n",
                styles: ["@charset \"UTF-8\";@font-face{font-family:\"Glyphicons Halflings\";src:url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.eot);src:url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.eot?#iefix) format(\"embedded-opentype\"),url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.woff2) format(\"woff2\"),url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.woff) format(\"woff\"),url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.ttf) format(\"truetype\"),url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.svg#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:\"Glyphicons Halflings\";font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\u20AC\"}.glyphicon-minus:before{content:\"\u2212\"}.glyphicon-cloud:before{content:\"\u2601\"}.glyphicon-envelope:before{content:\"\u2709\"}.glyphicon-pencil:before{content:\"\u270F\"}.glyphicon-glass:before{content:\"\uE001\"}.glyphicon-music:before{content:\"\uE002\"}.glyphicon-search:before{content:\"\uE003\"}.glyphicon-heart:before{content:\"\uE005\"}.glyphicon-star:before{content:\"\uE006\"}.glyphicon-star-empty:before{content:\"\uE007\"}.glyphicon-user:before{content:\"\uE008\"}.glyphicon-film:before{content:\"\uE009\"}.glyphicon-th-large:before{content:\"\uE010\"}.glyphicon-th:before{content:\"\uE011\"}.glyphicon-th-list:before{content:\"\uE012\"}.glyphicon-ok:before{content:\"\uE013\"}.glyphicon-remove:before{content:\"\uE014\"}.glyphicon-zoom-in:before{content:\"\uE015\"}.glyphicon-zoom-out:before{content:\"\uE016\"}.glyphicon-off:before{content:\"\uE017\"}.glyphicon-signal:before{content:\"\uE018\"}.glyphicon-cog:before{content:\"\uE019\"}.glyphicon-trash:before{content:\"\uE020\"}.glyphicon-home:before{content:\"\uE021\"}.glyphicon-file:before{content:\"\uE022\"}.glyphicon-time:before{content:\"\uE023\"}.glyphicon-road:before{content:\"\uE024\"}.glyphicon-download-alt:before{content:\"\uE025\"}.glyphicon-download:before{content:\"\uE026\"}.glyphicon-upload:before{content:\"\uE027\"}.glyphicon-inbox:before{content:\"\uE028\"}.glyphicon-play-circle:before{content:\"\uE029\"}.glyphicon-repeat:before{content:\"\uE030\"}.glyphicon-refresh:before{content:\"\uE031\"}.glyphicon-list-alt:before{content:\"\uE032\"}.glyphicon-lock:before{content:\"\uE033\"}.glyphicon-flag:before{content:\"\uE034\"}.glyphicon-headphones:before{content:\"\uE035\"}.glyphicon-volume-off:before{content:\"\uE036\"}.glyphicon-volume-down:before{content:\"\uE037\"}.glyphicon-volume-up:before{content:\"\uE038\"}.glyphicon-qrcode:before{content:\"\uE039\"}.glyphicon-barcode:before{content:\"\uE040\"}.glyphicon-tag:before{content:\"\uE041\"}.glyphicon-tags:before{content:\"\uE042\"}.glyphicon-book:before{content:\"\uE043\"}.glyphicon-bookmark:before{content:\"\uE044\"}.glyphicon-print:before{content:\"\uE045\"}.glyphicon-camera:before{content:\"\uE046\"}.glyphicon-font:before{content:\"\uE047\"}.glyphicon-bold:before{content:\"\uE048\"}.glyphicon-italic:before{content:\"\uE049\"}.glyphicon-text-height:before{content:\"\uE050\"}.glyphicon-text-width:before{content:\"\uE051\"}.glyphicon-align-left:before{content:\"\uE052\"}.glyphicon-align-center:before{content:\"\uE053\"}.glyphicon-align-right:before{content:\"\uE054\"}.glyphicon-align-justify:before{content:\"\uE055\"}.glyphicon-list:before{content:\"\uE056\"}.glyphicon-indent-left:before{content:\"\uE057\"}.glyphicon-indent-right:before{content:\"\uE058\"}.glyphicon-facetime-video:before{content:\"\uE059\"}.glyphicon-picture:before{content:\"\uE060\"}.glyphicon-map-marker:before{content:\"\uE062\"}.glyphicon-adjust:before{content:\"\uE063\"}.glyphicon-tint:before{content:\"\uE064\"}.glyphicon-edit:before{content:\"\uE065\"}.glyphicon-share:before{content:\"\uE066\"}.glyphicon-check:before{content:\"\uE067\"}.glyphicon-move:before{content:\"\uE068\"}.glyphicon-step-backward:before{content:\"\uE069\"}.glyphicon-fast-backward:before{content:\"\uE070\"}.glyphicon-backward:before{content:\"\uE071\"}.glyphicon-play:before{content:\"\uE072\"}.glyphicon-pause:before{content:\"\uE073\"}.glyphicon-stop:before{content:\"\uE074\"}.glyphicon-forward:before{content:\"\uE075\"}.glyphicon-fast-forward:before{content:\"\uE076\"}.glyphicon-step-forward:before{content:\"\uE077\"}.glyphicon-eject:before{content:\"\uE078\"}.glyphicon-chevron-left:before{content:\"\uE079\"}.glyphicon-chevron-right:before{content:\"\uE080\"}.glyphicon-plus-sign:before{content:\"\uE081\"}.glyphicon-minus-sign:before{content:\"\uE082\"}.glyphicon-remove-sign:before{content:\"\uE083\"}.glyphicon-ok-sign:before{content:\"\uE084\"}.glyphicon-question-sign:before{content:\"\uE085\"}.glyphicon-info-sign:before{content:\"\uE086\"}.glyphicon-screenshot:before{content:\"\uE087\"}.glyphicon-remove-circle:before{content:\"\uE088\"}.glyphicon-ok-circle:before{content:\"\uE089\"}.glyphicon-ban-circle:before{content:\"\uE090\"}.glyphicon-arrow-left:before{content:\"\uE091\"}.glyphicon-arrow-right:before{content:\"\uE092\"}.glyphicon-arrow-up:before{content:\"\uE093\"}.glyphicon-arrow-down:before{content:\"\uE094\"}.glyphicon-share-alt:before{content:\"\uE095\"}.glyphicon-resize-full:before{content:\"\uE096\"}.glyphicon-resize-small:before{content:\"\uE097\"}.glyphicon-exclamation-sign:before{content:\"\uE101\"}.glyphicon-gift:before{content:\"\uE102\"}.glyphicon-leaf:before{content:\"\uE103\"}.glyphicon-fire:before{content:\"\uE104\"}.glyphicon-eye-open:before{content:\"\uE105\"}.glyphicon-eye-close:before{content:\"\uE106\"}.glyphicon-warning-sign:before{content:\"\uE107\"}.glyphicon-plane:before{content:\"\uE108\"}.glyphicon-calendar:before{content:\"\uE109\"}.glyphicon-random:before{content:\"\uE110\"}.glyphicon-comment:before{content:\"\uE111\"}.glyphicon-magnet:before{content:\"\uE112\"}.glyphicon-chevron-up:before{content:\"\uE113\"}.glyphicon-chevron-down:before{content:\"\uE114\"}.glyphicon-retweet:before{content:\"\uE115\"}.glyphicon-shopping-cart:before{content:\"\uE116\"}.glyphicon-folder-close:before{content:\"\uE117\"}.glyphicon-folder-open:before{content:\"\uE118\"}.glyphicon-resize-vertical:before{content:\"\uE119\"}.glyphicon-resize-horizontal:before{content:\"\uE120\"}.glyphicon-hdd:before{content:\"\uE121\"}.glyphicon-bullhorn:before{content:\"\uE122\"}.glyphicon-bell:before{content:\"\uE123\"}.glyphicon-certificate:before{content:\"\uE124\"}.glyphicon-thumbs-up:before{content:\"\uE125\"}.glyphicon-thumbs-down:before{content:\"\uE126\"}.glyphicon-hand-right:before{content:\"\uE127\"}.glyphicon-hand-left:before{content:\"\uE128\"}.glyphicon-hand-up:before{content:\"\uE129\"}.glyphicon-hand-down:before{content:\"\uE130\"}.glyphicon-circle-arrow-right:before{content:\"\uE131\"}.glyphicon-circle-arrow-left:before{content:\"\uE132\"}.glyphicon-circle-arrow-up:before{content:\"\uE133\"}.glyphicon-circle-arrow-down:before{content:\"\uE134\"}.glyphicon-globe:before{content:\"\uE135\"}.glyphicon-wrench:before{content:\"\uE136\"}.glyphicon-tasks:before{content:\"\uE137\"}.glyphicon-filter:before{content:\"\uE138\"}.glyphicon-briefcase:before{content:\"\uE139\"}.glyphicon-fullscreen:before{content:\"\uE140\"}.glyphicon-dashboard:before{content:\"\uE141\"}.glyphicon-paperclip:before{content:\"\uE142\"}.glyphicon-heart-empty:before{content:\"\uE143\"}.glyphicon-link:before{content:\"\uE144\"}.glyphicon-phone:before{content:\"\uE145\"}.glyphicon-pushpin:before{content:\"\uE146\"}.glyphicon-usd:before{content:\"\uE148\"}.glyphicon-gbp:before{content:\"\uE149\"}.glyphicon-sort:before{content:\"\uE150\"}.glyphicon-sort-by-alphabet:before{content:\"\uE151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\uE152\"}.glyphicon-sort-by-order:before{content:\"\uE153\"}.glyphicon-sort-by-order-alt:before{content:\"\uE154\"}.glyphicon-sort-by-attributes:before{content:\"\uE155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\uE156\"}.glyphicon-unchecked:before{content:\"\uE157\"}.glyphicon-expand:before{content:\"\uE158\"}.glyphicon-collapse-down:before{content:\"\uE159\"}.glyphicon-collapse-up:before{content:\"\uE160\"}.glyphicon-log-in:before{content:\"\uE161\"}.glyphicon-flash:before{content:\"\uE162\"}.glyphicon-log-out:before{content:\"\uE163\"}.glyphicon-new-window:before{content:\"\uE164\"}.glyphicon-record:before{content:\"\uE165\"}.glyphicon-save:before{content:\"\uE166\"}.glyphicon-open:before{content:\"\uE167\"}.glyphicon-saved:before{content:\"\uE168\"}.glyphicon-import:before{content:\"\uE169\"}.glyphicon-export:before{content:\"\uE170\"}.glyphicon-send:before{content:\"\uE171\"}.glyphicon-floppy-disk:before{content:\"\uE172\"}.glyphicon-floppy-saved:before{content:\"\uE173\"}.glyphicon-floppy-remove:before{content:\"\uE174\"}.glyphicon-floppy-save:before{content:\"\uE175\"}.glyphicon-floppy-open:before{content:\"\uE176\"}.glyphicon-credit-card:before{content:\"\uE177\"}.glyphicon-transfer:before{content:\"\uE178\"}.glyphicon-cutlery:before{content:\"\uE179\"}.glyphicon-header:before{content:\"\uE180\"}.glyphicon-compressed:before{content:\"\uE181\"}.glyphicon-earphone:before{content:\"\uE182\"}.glyphicon-phone-alt:before{content:\"\uE183\"}.glyphicon-tower:before{content:\"\uE184\"}.glyphicon-stats:before{content:\"\uE185\"}.glyphicon-sd-video:before{content:\"\uE186\"}.glyphicon-hd-video:before{content:\"\uE187\"}.glyphicon-subtitles:before{content:\"\uE188\"}.glyphicon-sound-stereo:before{content:\"\uE189\"}.glyphicon-sound-dolby:before{content:\"\uE190\"}.glyphicon-sound-5-1:before{content:\"\uE191\"}.glyphicon-sound-6-1:before{content:\"\uE192\"}.glyphicon-sound-7-1:before{content:\"\uE193\"}.glyphicon-copyright-mark:before{content:\"\uE194\"}.glyphicon-registration-mark:before{content:\"\uE195\"}.glyphicon-cloud-download:before{content:\"\uE197\"}.glyphicon-cloud-upload:before{content:\"\uE198\"}.glyphicon-tree-conifer:before{content:\"\uE199\"}.glyphicon-tree-deciduous:before{content:\"\uE200\"}.glyphicon-cd:before{content:\"\uE201\"}.glyphicon-save-file:before{content:\"\uE202\"}.glyphicon-open-file:before{content:\"\uE203\"}.glyphicon-level-up:before{content:\"\uE204\"}.glyphicon-copy:before{content:\"\uE205\"}.glyphicon-paste:before{content:\"\uE206\"}.glyphicon-alert:before{content:\"\uE209\"}.glyphicon-equalizer:before{content:\"\uE210\"}.glyphicon-king:before{content:\"\uE211\"}.glyphicon-queen:before{content:\"\uE212\"}.glyphicon-pawn:before{content:\"\uE213\"}.glyphicon-bishop:before{content:\"\uE214\"}.glyphicon-knight:before{content:\"\uE215\"}.glyphicon-baby-formula:before{content:\"\uE216\"}.glyphicon-tent:before{content:\"\u26FA\"}.glyphicon-blackboard:before{content:\"\uE218\"}.glyphicon-bed:before{content:\"\uE219\"}.glyphicon-apple:before{content:\"\uF8FF\"}.glyphicon-erase:before{content:\"\uE221\"}.glyphicon-hourglass:before{content:\"\u231B\"}.glyphicon-lamp:before{content:\"\uE223\"}.glyphicon-duplicate:before{content:\"\uE224\"}.glyphicon-piggy-bank:before{content:\"\uE225\"}.glyphicon-scissors:before{content:\"\uE226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\uE227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\u00A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\u20BD\"}.glyphicon-scale:before{content:\"\uE230\"}.glyphicon-ice-lolly:before{content:\"\uE231\"}.glyphicon-ice-lolly-tasted:before{content:\"\uE232\"}.glyphicon-education:before{content:\"\uE233\"}.glyphicon-option-horizontal:before{content:\"\uE234\"}.glyphicon-option-vertical:before{content:\"\uE235\"}.glyphicon-menu-hamburger:before{content:\"\uE236\"}.glyphicon-modal-window:before{content:\"\uE237\"}.glyphicon-oil:before{content:\"\uE238\"}.glyphicon-grain:before{content:\"\uE239\"}.glyphicon-sunglasses:before{content:\"\uE240\"}.glyphicon-text-size:before{content:\"\uE241\"}.glyphicon-text-color:before{content:\"\uE242\"}.glyphicon-text-background:before{content:\"\uE243\"}.glyphicon-object-align-top:before{content:\"\uE244\"}.glyphicon-object-align-bottom:before{content:\"\uE245\"}.glyphicon-object-align-horizontal:before{content:\"\uE246\"}.glyphicon-object-align-left:before{content:\"\uE247\"}.glyphicon-object-align-vertical:before{content:\"\uE248\"}.glyphicon-object-align-right:before{content:\"\uE249\"}.glyphicon-triangle-right:before{content:\"\uE250\"}.glyphicon-triangle-left:before{content:\"\uE251\"}.glyphicon-triangle-bottom:before{content:\"\uE252\"}.glyphicon-triangle-top:before{content:\"\uE253\"}.glyphicon-console:before{content:\"\uE254\"}.glyphicon-superscript:before{content:\"\uE255\"}.glyphicon-subscript:before{content:\"\uE256\"}.glyphicon-menu-left:before{content:\"\uE257\"}.glyphicon-menu-right:before{content:\"\uE258\"}.glyphicon-menu-down:before{content:\"\uE259\"}.glyphicon-menu-up:before{content:\"\uE260\"}.sel{font-size:.7rem;display:inline-block;margin:10px 0;width:120px;background-color:transparent;border-bottom:4px solid rgba(0,0,0,.3);position:relative;cursor:pointer}.sel.large{width:200px}.sel.xlarge{width:400px}.sel.auto{width:50%;min-width:200px}.sel::before{position:absolute;content:\"\uF063\";font-family:FontAwesome;font-size:2em;color:#1e9df8;right:20px;top:calc(50% - .5em)}.sel.active::before{transform:rotateX(-180deg)}.sel__placeholder{display:block;font-family:Quicksand;font-size:2.3em;color:#1e9df8;padding:.2em .5em;text-align:left;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;visibility:visible}.sel.active .sel__placeholder{visibility:hidden}.sel__placeholder::before{position:absolute;top:0;bottom:0;left:0;right:0;padding:.2em .5em;content:attr(data-placeholder);visibility:hidden}.sel.active .sel__placeholder::before{visibility:visible}.sel__box{position:absolute;top:calc(100% + 4px);left:-4px;display:none;list-style-type:none;text-align:left;font-size:1em;background-color:#fff;width:calc(100% + 8px);box-sizing:border-box}.sel.active .sel__box{display:block;-webkit-animation:.5s fadeInUp;animation:.5s fadeInUp}.sel__box__options{display:list-item;font-family:Quicksand;font-size:1.5em;color:#838e95;padding:.5em 1em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.sel__box__options.disabled{color:#63b175;font-size:1.1em;padding-top:10px;padding-bottom:10px;background-color:#e9e9e9;text-transform:uppercase;cursor:text}.sel__box__options.selected{color:#1e9df8}.sel__box__options::after{content:\"\uF00C\";font-family:FontAwesome;font-size:.5em;margin-left:5px;display:none}.sel__box__options.selected::after{display:inline}.sel__box__options:hover{background-color:#ebedef}@-webkit-keyframes fadeInUp{from{opacity:0;transform:translate3d(0,20px,0)}to{opacity:1;transform:none}}@keyframes fadeInUp{from{opacity:0;transform:translate3d(0,20px,0)}to{opacity:1;transform:none}}@-webkit-keyframes fadeOut{from{opacity:1}to{opacity:0}}@keyframes fadeOut{from{opacity:1}to{opacity:0}}.row:after{clear:both;content:\"\";display:block}.row .col{float:left}.row .col:not(:first-child){margin-left:1%!important}.row .col-md-3{width:24%}.row .col-md-4{width:32%}.row .col-md-6{width:49%}.row .col-md-8{width:64%}.row .col-md-9{width:74%}.row .col-md-12{width:100%;margin-left:0}.form-group .col{margin:8px 0}.card{color:#555;padding:20px 0;background-color:#fff;border-radius:5px}.card .card_img{width:100px;margin:0 auto}.card .card_content{margin-top:10px;padding:5px 20px;border-top:1px solid #e5e5e5}.card .card_content .card_line span{display:inline-block;padding:5px 0}.card .card_content .card_line span.key{width:30%;text-align:right;color:#999}.card .card_content .card_line span.value{width:calc(70% - 20px);text-align:left;padding-left:20px}*{margin:0;padding:0}body{color:#555;font-size:16px;font-family:\"EB Garamond\",serif;background-color:#f9f9f9}a{color:#335a9c;text-decoration:none}a:hover{text-decoration:underline}.container{width:90%;max-width:940px;min-width:340px;margin:0 auto}.clearfix{clear:both}.clickable{cursor:pointer}.page{padding:10px 0;background-color:#fff;box-shadow:0 1px 1px #ddd}.page>div{margin:0 30px}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert.alert-primary{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.btn{padding:9px 10px;color:#000;background-color:transparent;border:1px solid #999;border-radius:3px;cursor:pointer}.btn.btn-sm{font-size:70%;padding:3px 10px}.btn:hover{background-color:transparent}.btn.btn-danger{color:#fff;background-color:#c00000;border-color:#c00000}.btn.btn-danger:hover{color:#c00000;background-color:#fff}.btn.btn-primary{color:#fff;background-color:#335a9c;border-color:#335a9c}.btn.btn-primary:hover{color:#335a9c;background-color:#fff}.btn.btn-primary:disabled{color:#fff;background-color:rgba(51,90,156,.5);border-color:transparent}.btn.btn-success{color:#fff;background-color:#63b175;border-color:#63b175}.btn.btn-success:hover{color:#63b175;background-color:#fff}.btn.btn-success:disabled{color:#fff;background-color:rgba(99,177,117,.5);border-color:transparent}.btn.btn-secondary{color:#888;background-color:#f1f1f1;border-color:#c2c3c4}.btn.btn-secondary:hover{color:#888;background-color:#f9f9f9}.btn.btn-image{font-size:10px;padding:3px 8px 3px 1px;border-color:#335a9c;text-decoration:none}.btn.btn-image:hover{color:#335a9c;background-color:rgba(240,240,240,.9);text-decoration:none}.btn.btn-image i{display:inline-block;vertical-align:middle}.filter .sel:not(:first-child){margin-left:20px}.form label{display:block;margin-bottom:10px}.form label input,.form label textarea{width:calc(100% - 10px);display:block;margin-top:5px;padding:3px 5px;border:1px solid #ddd;border-radius:3px}.form label input{height:30px}.form label textarea{height:50px}.form button{padding:10px;color:#63b175;border:1px solid #335a9c;border-radius:3px;cursor:pointer}.form button:hover{color:#fff;background-color:#335a9c}.form .form-separator{color:#335a9c;font-size:80%;padding-bottom:5px;margin:30px 0 10px;text-transform:uppercase;border-bottom:1px solid #335a9c}.form-control:disabled{background-color:#eee;cursor:text}h3.title{font-size:30px;margin-bottom:20px}h3.title a{font-size:13px;margin-top:15px;display:inline-block;color:#335a9c;text-decoration:none;text-transform:uppercase}h3.title a:hover{text-decoration:underline}.hidden{display:none!important}.nowrap{white-space:nowrap}.pagination{text-align:right}.pagination a{color:#fff;margin:0 5px;padding:5px 15px;text-align:center;display:inline-block;background-color:#335a9c;cursor:pointer}.pagination a.active,.pagination a:hover{background-color:#335a9c}.pagination a.disabled{background-color:rgba(51,90,156,.5);text-decoration:none;cursor:text}.pull-right{float:right}.table{width:100%;border-collapse:collapse}.table td,.table th{padding:10px}.table thead th{text-align:left;border-bottom:1px solid #777}.table tbody tr:nth-child(odd) td{background-color:#f5f5f5}.table tbody tr:not(:first-child) td{border-top:1px solid #fff}.table tbody tr td.actions{width:100px;text-align:center}.table tbody tr td.actions.small{width:50px}.table tbody tr td.actions i{font-size:120%;display:inline-block;vertical-align:middle;cursor:pointer}.table tbody tr td.actions i:not(:first-child){margin-left:10px}.table tbody tr td.actions i:first-child{color:#63b175}.table tbody tr td.actions i:nth-child(2){color:#335a9c}.table tbody tr td.actions i:last-child{color:#c00000}.table tbody tr td.actions i:hover{color:#335a9c}.table tbody tr td img{width:20px;cursor:pointer}.table tbody tr td img:not(:first-child){margin-left:10px}.table tbody tr td img.avatar{width:30px}.table tbody tr td .story,.table tbody tr td a{color:#335a9c}.table tbody tr .text-small{font-size:11px}.table tfoot tr td{border-top:1px solid #777}.table.table-small td{padding-top:5px;padding-bottom:5px}.table.stripped tr:nth-child(odd) td{background-color:#fff}.table.stripped tr td:not(:first-child){border-left:1px solid #fff}.table.stripped tr td.icon-holder{text-align:center;vertical-align:middle}.table.stripped tr td.icon-holder .cash-icon{width:20px}.text-center{text-align:center!important}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-bold{font-weight:600}.text-blue{color:#335a9c!important}.text-gray{color:#888!important}.text-green{color:#63b175!important}.text-red{color:#c00000!important}.text-muted{color:#999}.text-small{font-size:80%}.text-uppercase{text-transform:uppercase}.text-no-break{white-space:nowrap}.text-ellipsis{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.modal{position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(0,0,0,.7)}.modal .modal-content{width:80%;max-width:500px;margin:20px auto;background-color:#fff;border-radius:3px}.modal .modal-content>*{padding:10px 20px}.modal .modal-content .modal-head{font-weight:700;color:#335a9c;text-transform:uppercase;border-bottom:1px solid #999}.modal .modal-content .modal-body{padding-top:20px}.modal .modal-content .modal-body .form-group label:not(:first-child){margin-top:0}.modal .modal-content .modal-body .btn-group{text-align:right}.btn-group{margin-top:20px}.btn-group .btn{display:inline-block;text-transform:uppercase}.btn-group .btn:not(.btn-sm){padding:6px 10px}.btn-group .btn:not(:first-child){margin-left:10px}.btn-group .btn.btn-cancel{color:#555;border-color:#ebedef}.btn-group .btn.btn-cancel:hover{color:#999;border-color:#999}.btn-group .btn.btn-apply{color:#fff;background-color:#63b175;border-color:#63b175}.btn-group .btn.btn-apply:hover{opacity:.6}.btn-group .btn.btn-apply:disabled{color:#555;background-color:#ebedef;border-color:#ebedef}.btn-group .btn.btn-delete{color:#fff;background-color:#c00000;border-color:#c00000}.btn-group .btn.btn-delete:hover{opacity:.6}.form-group label{display:block}.form-group label:not(:first-child){margin-top:10px}.form-group label[class^=col-].mgn-lt{margin-left:10px}.form-group label.labeled input{margin-top:5px}.form-group label>span{display:block;padding:5px 0;color:#555;text-transform:capitalize}.form-group label .radio span{padding:5px 10px;width:calc(49% - 22px);display:inline-block;text-align:center;border:1px solid #999;border-radius:3px;text-transform:capitalize;cursor:pointer}.form-group label .radio span:last-child{margin-left:2%}.form-group label .radio span:hover{color:#335a9c;border-color:#335a9c}.form-group label .radio span.active{color:#fff;background-color:#335a9c;border-color:#335a9c}.form-group .form-control{padding:8px 10px;width:calc(100% - 20px);border:1px solid #999;border-radius:3px}.form-group select.form-control{width:100%}.form-group select.form-control.no_fill{width:auto;min-width:100px}.form-group select.form-control.no_fill:not(:first-child){margin-left:10px}header{min-height:100px;position:relative;background-color:#fff}header .logo_holder{position:absolute;top:0;left:0;padding:20px 0 0 30px}header .logo_holder img{width:150px;display:block}header .logo_holder span{color:#335a9c;font-size:14px;text-transform:uppercase}header .content-user{position:absolute;top:30px;right:0;height:60px;background-color:#fff}header .content-user span{position:absolute;top:10px;right:80px;text-align:right;white-space:nowrap}header .content-user span a{color:#335a9c}header .content-user span small{display:block}header .content-user img{position:absolute;top:10px;right:30px;width:40px;height:40px}header nav{background-color:#394264}header nav a{width:90px;padding:7px 15px;margin-left:10px;margin-bottom:5px;text-align:center;display:inline-block;color:#fff;cursor:pointer;border-bottom:3px solid #fff}header nav a.active{border-color:#e64c65}header nav a:hover{border-color:#e64c65;color:#e64c65;text-decoration:none}header .sub-nav{background-color:#f1f1f1}header .sub-nav a{width:90px;margin-top:2px;margin-left:10px;margin-bottom:5px;padding:7px 15px;color:#777;text-align:center;display:inline-block;border-bottom:3px solid #777;cursor:pointer}header .sub-nav a:hover{color:#63b175;border-color:#63b175;text-decoration:none}header .sub-nav a.active{color:#e64c65;border-color:#e64c65}footer{margin:20px 30px;text-align:right}.bubble{padding:8px;display:inline-block;background-color:#f1f1f1;border-radius:8px}.bubble.green{background-color:#63b175}.bubble.red{background-color:#c00000}"]
            }] }
];
/** @nocollapse */
RootComponent.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipe/sort.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SortPipe {
    /**
     * @param {?} items
     * @param {?} field
     * @return {?}
     */
    transform(items, field) {
        if (!items) {
            return [];
        }
        // sort by field
        if (field) {
            items.sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            (a, b) => a[field] > b[field] ? 1 : -1));
        }
        return items;
    }
}
SortPipe.decorators = [
    { type: Pipe, args: [{ name: 'orderBy' },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/date.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DateService {
    /**
     * @return {?}
     */
    static getMonths() {
        return [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
    }
    /**
     * @param {?} month
     * @return {?}
     */
    static getMonthName(month) {
        /** @type {?} */
        const months = this.getMonths();
        return months[month - 1] ? months[month - 1] : undefined;
    }
    /**
     * @param {?} start
     * @param {?} end
     * @return {?}
     */
    static getMonthsInRange(start, end) {
        /** @type {?} */
        const arr = [];
        for (let date = new Date(start); date <= end; date.setMonth(date.getMonth() + 1)) {
            arr.push(new Date(date));
        }
        return arr;
    }
    /**
     * @return {?}
     */
    static getYears() {
        /** @type {?} */
        const currYear = new Date().getFullYear();
        /** @type {?} */
        const years = [];
        for (let year = 2019; year <= currYear; year++) {
            years.push(year);
        }
        return years;
    }
    /**
     * @param {?} timestamp
     * @return {?}
     */
    static isToday(timestamp) {
        /** @type {?} */
        const date = DateService.mapTimestampToDate(timestamp);
        return date == DateService.now();
    }
    /**
     * @param {?} timestamp
     * @return {?}
     */
    static isFuture(timestamp) {
        /** @type {?} */
        const date = DateService.mapTimestampToDate(timestamp);
        return date > DateService.now();
    }
    /**
     * @param {?} timestamp
     * @return {?}
     */
    static isPast(timestamp) {
        /** @type {?} */
        const date = DateService.mapTimestampToDate(timestamp);
        return date < DateService.now();
    }
    /**
     * @param {?} date
     * @return {?}
     */
    static isCurrentMonth(date) {
        /** @type {?} */
        const today = DateService.now();
        return (today.getFullYear() === date.getFullYear()
            && today.getMonth() === date.getMonth());
    }
    /**
     * @param {?} timestamp
     * @return {?}
     */
    static mapTimestampToDate(timestamp) {
        /** @type {?} */
        const date = new Date(timestamp);
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }
    /**
     * @return {?}
     */
    static now() {
        return DateService.mapTimestampToDate(new Date().getTime());
    }
}
DateService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ DateService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DateService_Factory() { return new DateService(); }, token: DateService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/file.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FileService {
    /**
     * @param {?} filename
     * @param {?} base64String
     * @return {?}
     */
    download(filename, base64String) {
        if (base64String.startsWith('data:application')) {
            base64String = base64String.replace('data:application/pdf;base64,', '');
        }
        /** @type {?} */
        const link = document.createElement('a');
        link.href = 'data:application/octet-stream;base64,' + base64String;
        link.download = filename;
        link.className = 'hide';
        // draw link and click
        document.body.appendChild(link);
        link.click();
        // remove link
        document.body.removeChild(link);
    }
    /**
     * @param {?} base64String
     * @return {?}
     */
    downloadExcel(base64String) {
        window.open('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64String);
    }
}
FileService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ FileService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FileService_Factory() { return new FileService(); }, token: FileService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/rest/rest.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RestService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @private
     * @return {?}
     */
    static getAuthorization() {
        /** @type {?} */
        let headers = new HttpHeaders();
        /** @type {?} */
        const authToken = (sessionStorage.getItem('token') != null)
            ? sessionStorage.getItem('token')
            : '';
        headers = headers.set('Authorization', authToken);
        return headers;
    }
    /**
     * @param {?} url
     * @return {?}
     */
    get(url) {
        return this.http.get(url, { headers: RestService.getAuthorization() });
    }
    /**
     * @param {?} url
     * @return {?}
     */
    getString(url) {
        return this.http.get(url, {
            headers: RestService.getAuthorization(),
            responseType: 'text'
        }).toPromise();
    }
    /**
     * @param {?} url
     * @param {?} body
     * @return {?}
     */
    post(url, body) {
        return this.http.post(url, body, { headers: RestService.getAuthorization() });
    }
    /**
     * @param {?} url
     * @param {?} body
     * @param {?} headers
     * @return {?}
     */
    postWithHeaders(url, body, headers) {
        return this.http.post(url, body, { headers: headers });
    }
    /**
     * @param {?} url
     * @param {?} body
     * @return {?}
     */
    put(url, body) {
        return this.http.put(url, body, { headers: RestService.getAuthorization() });
    }
    /**
     * @param {?} url
     * @return {?}
     */
    delete(url) {
        return this.http.delete(url, { headers: RestService.getAuthorization() });
    }
    /**
     * @param {?} url
     * @return {?}
     */
    download(url) {
        return this.http.get(url, {
            headers: RestService.getAuthorization(),
            responseType: 'text'
        }).toPromise();
    }
}
RestService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
RestService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ RestService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RestService_Factory() { return new RestService(ɵɵinject(HttpClient)); }, token: RestService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    RestService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/person.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PersonService {
    /**
     * @param {?} rest
     */
    constructor(rest) {
        this.rest = rest;
    }
    /**
     * @return {?}
     */
    findAll() {
        return this.rest.get(PersonService.URL).toPromise();
    }
    /**
     * @param {?} roleId
     * @return {?}
     */
    findByRole(roleId) {
        return this.rest.get(PersonService.URL + '/role/' + roleId).toPromise();
    }
    /**
     * @param {?} pseudo
     * @return {?}
     */
    findByPseudo(pseudo) {
        return this.rest.get(PersonService.URL + '/pseudo/' + pseudo).toPromise();
    }
    /**
     * @param {?} email
     * @return {?}
     */
    findPersonByEmail(email) {
        return this.rest.get(PersonService.URL + '/email/' + email).toPromise();
    }
    /**
     * @param {?} id
     * @return {?}
     */
    findById(id) {
        return this.rest.get(PersonService.URL + '/' + id).toPromise();
    }
    /**
     * @param {?} person
     * @return {?}
     */
    insert(person) {
        return this.rest.post(PersonService.URL, person)
            .toPromise();
    }
    /**
     * @param {?} id
     * @param {?} person
     * @return {?}
     */
    update(id, person) {
        return this.rest.put(PersonService.URL + '/' + person.id, person)
            .toPromise();
    }
    /**
     * @param {?} personId
     * @param {?} avatar
     * @return {?}
     */
    updateAvatar(personId, avatar) {
        return this.rest.put(PersonService.URL + '/' + personId + '/avatar', avatar)
            .toPromise();
    }
    /**
     * @param {?} personId
     * @param {?} password
     * @return {?}
     */
    updatePassword(personId, password) {
        return this.rest.put(PersonService.URL + '/' + personId + '/password', password)
            .toPromise();
    }
}
PersonService.URL = APP_URL_TEAM + '/persons';
PersonService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
PersonService.ctorParameters = () => [
    { type: RestService }
];
/** @nocollapse */ PersonService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PersonService_Factory() { return new PersonService(ɵɵinject(RestService)); }, token: PersonService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    PersonService.URL;
    /**
     * @type {?}
     * @private
     */
    PersonService.prototype.rest;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/authentication/authentication.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthenticationService {
    /**
     * @param {?} rest
     * @param {?} _personService
     */
    constructor(rest, _personService) {
        this.rest = rest;
        this._personService = _personService;
        this.authenticated = new BehaviorSubject(false);
    }
    /**
     * @return {?}
     */
    isLoggedIn() {
        return this.authenticated;
    }
    /**
     * @return {?}
     */
    lastUpdateTime() {
        /** @type {?} */
        const lastUpdate = sessionStorage.getItem('token_update');
        return lastUpdate ? Number(lastUpdate) : -1;
    }
    /**
     * @return {?}
     */
    getToken() {
        return this.rest.get(AuthenticationService.URI + '/token')
            .toPromise();
    }
    /**
     * @return {?}
     */
    getPerson() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.rest.get(AuthenticationService.URI)
                .pipe(map((/**
             * @param {?} person
             * @return {?}
             */
            person => {
                this.person = person && person.id ? person : null;
                this.authenticated.next(this.person != null);
                sessionStorage.setItem('token_update', String(Date.now()));
                return this.person;
            }))).toPromise();
        });
    }
    /**
     * @param {?} email
     * @param {?} password
     * @param {?} callback
     * @return {?}
     */
    login(email, password, callback) {
        this.rest.get(AuthenticationService.URI + '/login?email=' + email + '&password=' + password)
            .subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            if (response && response.token) {
                sessionStorage.setItem('token', response.token);
                sessionStorage.setItem('token_update', String(Date.now()));
            }
            else {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('token_update');
            }
            callback(response);
        }));
    }
    /**
     * @return {?}
     */
    logout() {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('token_update');
        // destroy session reference
        this.authenticated.next(false);
        this.person = null;
        this.token = null;
    }
}
AuthenticationService.URI = APP_URL_TEAM + '/auth';
AuthenticationService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
AuthenticationService.ctorParameters = () => [
    { type: RestService },
    { type: PersonService }
];
/** @nocollapse */ AuthenticationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(ɵɵinject(RestService), ɵɵinject(PersonService)); }, token: AuthenticationService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    AuthenticationService.URI;
    /** @type {?} */
    AuthenticationService.prototype.person;
    /** @type {?} */
    AuthenticationService.prototype.token;
    /**
     * @type {?}
     * @private
     */
    AuthenticationService.prototype.authenticated;
    /**
     * @type {?}
     * @private
     */
    AuthenticationService.prototype.rest;
    /**
     * @type {?}
     * @private
     */
    AuthenticationService.prototype._personService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/person-role.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PersonRoleService {
    /**
     * @param {?} rest
     */
    constructor(rest) {
        this.rest = rest;
    }
    /**
     * @return {?}
     */
    findAll() {
        return this.rest.get(PersonRoleService.URL).toPromise();
    }
    /**
     * @param {?} id
     * @return {?}
     */
    findById(id) {
        return this.rest.get(PersonRoleService.URL + '/' + id).toPromise();
    }
    /**
     * @param {?} name
     * @return {?}
     */
    findByName(name) {
        return this.rest.get(PersonRoleService.URL + '/name/' + name).toPromise();
    }
    /**
     * @param {?} role
     * @return {?}
     */
    insert(role) {
        return this.rest.post(PersonRoleService.URL, role)
            .toPromise();
    }
    /**
     * @param {?} id
     * @param {?} role
     * @return {?}
     */
    update(id, role) {
        return this.rest.put(PersonRoleService.URL + '/' + id, role)
            .toPromise();
    }
    /**
     * @param {?} id
     * @return {?}
     */
    delete(id) {
        return this.rest.delete(PersonRoleService.URL + '/' + id)
            .toPromise();
    }
}
PersonRoleService.URL = APP_URL_TEAM + '/persons/roles';
PersonRoleService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
PersonRoleService.ctorParameters = () => [
    { type: RestService }
];
/** @nocollapse */ PersonRoleService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PersonRoleService_Factory() { return new PersonRoleService(ɵɵinject(RestService)); }, token: PersonRoleService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    PersonRoleService.URL;
    /**
     * @type {?}
     * @private
     */
    PersonRoleService.prototype.rest;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/customer.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CustomerService {
    /**
     * @param {?} restService
     */
    constructor(restService) {
        this.restService = restService;
    }
    /**
     * @return {?}
     */
    findAll() {
        return this.restService.get(CustomerService.URL)
            .toPromise();
    }
    /**
     * @param {?} id
     * @return {?}
     */
    findById(id) {
        return this.restService.get(CustomerService.URL + '/' + id)
            .toPromise();
    }
    /**
     * @param {?} customer
     * @return {?}
     */
    insert(customer) {
        return this.restService.post(CustomerService.URL, customer)
            .toPromise();
    }
    /**
     * @param {?} id
     * @param {?} customer
     * @return {?}
     */
    update(id, customer) {
        return this.restService.put(CustomerService.URL + '/' + id, customer)
            .toPromise();
    }
    /**
     * @param {?} id
     * @return {?}
     */
    delete(id) {
        return this.restService.delete(CustomerService.URL + '/' + id)
            .toPromise();
    }
}
CustomerService.URL = APP_URL_TEAM + '/customers';
CustomerService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CustomerService.ctorParameters = () => [
    { type: RestService }
];
/** @nocollapse */ CustomerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CustomerService_Factory() { return new CustomerService(ɵɵinject(RestService)); }, token: CustomerService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    CustomerService.URL;
    /**
     * @type {?}
     * @private
     */
    CustomerService.prototype.restService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/project.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProjectService {
    /**
     * @param {?} rest
     */
    constructor(rest) {
        this.rest = rest;
    }
    /**
     * @return {?}
     */
    findAll() {
        return this.rest.get(ProjectService.URL)
            .toPromise();
    }
    /**
     * @param {?} customerId
     * @return {?}
     */
    findByCustomer(customerId) {
        return this.rest.get(ProjectService.URL)
            .pipe(map((/**
         * @param {?} projects
         * @return {?}
         */
        projects => {
            return projects.filter((/**
             * @param {?} project
             * @return {?}
             */
            project => (project.customerId === customerId)));
        })))
            .toPromise();
    }
    /**
     * @param {?} id
     * @return {?}
     */
    findById(id) {
        return this.rest.get(ProjectService.URL + '/' + id)
            .toPromise();
    }
    /**
     * @param {?} project
     * @return {?}
     */
    insert(project) {
        return this.rest.post(ProjectService.URL, project)
            .toPromise();
    }
    /**
     * @param {?} id
     * @param {?} project
     * @return {?}
     */
    update(id, project) {
        return this.rest.put(ProjectService.URL + '/' + id, project)
            .toPromise();
    }
    /**
     * @param {?} id
     * @return {?}
     */
    delete(id) {
        return this.rest.delete(ProjectService.URL + '/' + id)
            .toPromise();
    }
}
ProjectService.URL = APP_URL_TEAM + '/projects';
ProjectService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ProjectService.ctorParameters = () => [
    { type: RestService }
];
/** @nocollapse */ ProjectService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ProjectService_Factory() { return new ProjectService(ɵɵinject(RestService)); }, token: ProjectService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ProjectService.URL;
    /**
     * @type {?}
     * @private
     */
    ProjectService.prototype.rest;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/header/header.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HeaderComponent {
    /**
     * @param {?} _cd
     * @param {?} _authService
     */
    constructor(_cd, _authService) {
        this._cd = _cd;
        this._authService = _authService;
        this.host = window.location.host;
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this.token != null) {
            sessionStorage.setItem('token', this.token);
        }
        this.getPerson().then((/**
         * @return {?}
         */
        () => {
            this._authService.isLoggedIn().subscribe((/**
             * @param {?} value
             * @return {?}
             */
            value => {
                this.isLoggedIn = value;
                this._cd.markForCheck();
            }));
        }));
    }
    /**
     * @private
     * @return {?}
     */
    getPerson() {
        return __awaiter(this, void 0, void 0, function* () {
            this._authService.getPerson()
                .then((/**
             * @param {?} person
             * @return {?}
             */
            person => {
                this.person = (person !== null) ? this._authService.person : null;
                // reload application
                if (this.token !== null) {
                    window.location.href = !window.location.host.includes('localhost')
                        ? 'https://' + window.location.host
                        : 'http://' + window.location.host;
                }
            }));
        });
    }
}
HeaderComponent.decorators = [
    { type: Component, args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'sleek-commons-header',
                template: "<ng-container>\n  <header>\n    <div class=\"logo_holder\">\n      <img src=\"https://www.sleeksys.com/assets/images/logo-large.png\" alt=\"logo\">\n      <span>{{ appName }}</span>\n    </div>\n\n    <div class=\"content-user\">\n          <span>\n            <a *ngIf=\"isLoggedIn\" class=\"clickable\" [routerLink]=\"'/me'\">\n              {{ person?.firstName }} {{ person?.lastName }}\n            </a>\n            <small>\n              Sleek Systems UG\n              &nbsp;.&nbsp;\n              <a *ngIf=\"isLoggedIn\" class=\"text-red text-small text-uppercase\"\n                 href=\"https://auth.sleeksys.com/#/logout\">Sign Out</a>\n\n              <a *ngIf=\"!isLoggedIn\" class=\"text-red text-small text-uppercase\"\n                 [href]=\"'https://auth.sleeksys.com/#/login?hs=' + host\">Sign In</a>\n            </small>\n          </span>\n\n      <img src=\"https://time.sleeksys.de/assets/images/avatar/man_2.png\"\n           alt=\"user-avatar\">\n    </div>\n\n  </header>\n</ng-container>\n"
            }] }
];
/** @nocollapse */
HeaderComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: AuthenticationService }
];
HeaderComponent.propDecorators = {
    token: [{ type: Input }],
    appName: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    HeaderComponent.prototype.token;
    /** @type {?} */
    HeaderComponent.prototype.appName;
    /** @type {?} */
    HeaderComponent.prototype.person;
    /** @type {?} */
    HeaderComponent.prototype.isLoggedIn;
    /** @type {?} */
    HeaderComponent.prototype.host;
    /**
     * @type {?}
     * @private
     */
    HeaderComponent.prototype._cd;
    /**
     * @type {?}
     * @private
     */
    HeaderComponent.prototype._authService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/footer/footer.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FooterComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.currentYear = new Date().getFullYear();
    }
}
FooterComponent.decorators = [
    { type: Component, args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'sleek-commons-footer',
                template: "<ng-container>\n  <footer>\n    <div>{{ currentYear }} &copy; Sleek Systems</div>\n  </footer>\n</ng-container>\n"
            }] }
];
/** @nocollapse */
FooterComponent.ctorParameters = () => [];
if (false) {
    /** @type {?} */
    FooterComponent.prototype.currentYear;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/alert/alert-error/alert-error.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AlertErrorComponent {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    /**
     * @return {?}
     */
    onClose() {
        /** @type {?} */
        const elt = ((/** @type {?} */ (this.elementRef.nativeElement)));
        elt.remove();
    }
}
AlertErrorComponent.decorators = [
    { type: Component, args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'sleek-alert-error',
                template: "<ng-container>\n  <div class=\"alert alert-danger\">\n    <span class=\"head\">{{ title || 'error' }}</span>\n\n    <span *ngIf=\"closeable\"\n          class=\"close\"\n          (click)=\"onClose()\">&#10005;</span>\n\n    <p>{{ message }}</p>\n\n    <ng-content></ng-content>\n  </div>\n</ng-container>\n",
                styles: [".alert{position:relative;min-height:30px;background-color:#fff;border-color:#ddd;border-top:4px solid #ddd}.alert span{position:absolute}.alert span.head{left:-10px;width:50px;color:#fff;font-size:12px;font-weight:500;padding:5px 10px;text-align:center;background-color:#ddd;text-transform:uppercase;border-radius:5px}.alert span.close{top:5px;right:15px;color:#ddd;font-size:20px;background-color:transparent;cursor:pointer}.alert p{color:#555;margin-left:50px;margin-right:20px}.alert.alert-danger{border-top-color:#c00000}.alert.alert-danger span.head{background-color:#c00000}.alert.alert-danger span.close{color:#c00000}.alert.alert-info{border-top-color:#335a9c}.alert.alert-info span.head{background-color:#335a9c}.alert.alert-info span.close{color:#335a9c}.alert.alert-success{border-top-color:#155724}.alert.alert-success span.head{background-color:#155724}.alert.alert-success span.close{color:#155724}"]
            }] }
];
/** @nocollapse */
AlertErrorComponent.ctorParameters = () => [
    { type: ElementRef }
];
AlertErrorComponent.propDecorators = {
    title: [{ type: Input }],
    message: [{ type: Input }],
    closeable: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    AlertErrorComponent.prototype.title;
    /** @type {?} */
    AlertErrorComponent.prototype.message;
    /** @type {?} */
    AlertErrorComponent.prototype.closeable;
    /**
     * @type {?}
     * @private
     */
    AlertErrorComponent.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/alert/alert-info/alert-info.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AlertInfoComponent {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    /**
     * @return {?}
     */
    onClose() {
        /** @type {?} */
        const elt = ((/** @type {?} */ (this.elementRef.nativeElement)));
        elt.remove();
    }
}
AlertInfoComponent.decorators = [
    { type: Component, args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'sleek-alert-info',
                template: "<ng-container>\n  <div class=\"alert alert-info\">\n    <span class=\"head\">{{ title || 'info' }}</span>\n\n    <span *ngIf=\"closeable\"\n          class=\"close\"\n          (click)=\"onClose()\">&#10005;</span>\n\n    <p>{{ message }}</p>\n\n    <ng-content></ng-content>\n  </div>\n</ng-container>\n",
                styles: [".alert{position:relative;min-height:30px;background-color:#fff;border-color:#ddd;border-top:4px solid #ddd}.alert span{position:absolute}.alert span.head{left:-10px;width:50px;color:#fff;font-size:12px;font-weight:500;padding:5px 10px;text-align:center;background-color:#ddd;text-transform:uppercase;border-radius:5px}.alert span.close{top:5px;right:15px;color:#ddd;font-size:20px;background-color:transparent;cursor:pointer}.alert p{color:#555;margin-left:50px;margin-right:20px}.alert.alert-danger{border-top-color:#c00000}.alert.alert-danger span.head{background-color:#c00000}.alert.alert-danger span.close{color:#c00000}.alert.alert-info{border-top-color:#335a9c}.alert.alert-info span.head{background-color:#335a9c}.alert.alert-info span.close{color:#335a9c}.alert.alert-success{border-top-color:#155724}.alert.alert-success span.head{background-color:#155724}.alert.alert-success span.close{color:#155724}"]
            }] }
];
/** @nocollapse */
AlertInfoComponent.ctorParameters = () => [
    { type: ElementRef }
];
AlertInfoComponent.propDecorators = {
    title: [{ type: Input }],
    message: [{ type: Input }],
    closeable: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    AlertInfoComponent.prototype.title;
    /** @type {?} */
    AlertInfoComponent.prototype.message;
    /** @type {?} */
    AlertInfoComponent.prototype.closeable;
    /**
     * @type {?}
     * @private
     */
    AlertInfoComponent.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/alert/alert-success/alert-success.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AlertSuccessComponent {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    /**
     * @return {?}
     */
    onClose() {
        /** @type {?} */
        const elt = ((/** @type {?} */ (this.elementRef.nativeElement)));
        elt.remove();
    }
}
AlertSuccessComponent.decorators = [
    { type: Component, args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'sleek-alert-success',
                template: "<ng-container>\n  <div class=\"alert alert-success\">\n    <span class=\"head\">{{ title || 'success' }}</span>\n\n    <span *ngIf=\"closeable\"\n          class=\"close\"\n          (click)=\"onClose()\">&#10005;</span>\n\n    <p>{{ message }}</p>\n\n    <ng-content></ng-content>\n  </div>\n</ng-container>\n",
                styles: [".alert{position:relative;min-height:30px;background-color:#fff;border-color:#ddd;border-top:4px solid #ddd}.alert span{position:absolute}.alert span.head{left:-10px;width:50px;color:#fff;font-size:12px;font-weight:500;padding:5px 10px;text-align:center;background-color:#ddd;text-transform:uppercase;border-radius:5px}.alert span.close{top:5px;right:15px;color:#ddd;font-size:20px;background-color:transparent;cursor:pointer}.alert p{color:#555;margin-left:50px;margin-right:20px}.alert.alert-danger{border-top-color:#c00000}.alert.alert-danger span.head{background-color:#c00000}.alert.alert-danger span.close{color:#c00000}.alert.alert-info{border-top-color:#335a9c}.alert.alert-info span.head{background-color:#335a9c}.alert.alert-info span.close{color:#335a9c}.alert.alert-success{border-top-color:#155724}.alert.alert-success span.head{background-color:#155724}.alert.alert-success span.close{color:#155724}"]
            }] }
];
/** @nocollapse */
AlertSuccessComponent.ctorParameters = () => [
    { type: ElementRef }
];
AlertSuccessComponent.propDecorators = {
    title: [{ type: Input }],
    message: [{ type: Input }],
    closeable: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    AlertSuccessComponent.prototype.title;
    /** @type {?} */
    AlertSuccessComponent.prototype.message;
    /** @type {?} */
    AlertSuccessComponent.prototype.closeable;
    /**
     * @type {?}
     * @private
     */
    AlertSuccessComponent.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/button/button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ButtonComponent {
    constructor() {
        this.clicked = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onClick(event) {
        this.clicked.emit(event);
    }
}
ButtonComponent.decorators = [
    { type: Component, args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'sleek-button',
                template: "<ng-container>\n  <a [className]=\"image ? 'btn btn-image' : 'btn'\" (click)=\"onClick($event)\">\n    <ng-container *ngIf=\"image\">\n      <i class=\"material-icons\">{{ image }}</i>\n    </ng-container>\n    {{ text }}\n  </a>\n</ng-container>\n"
            }] }
];
/** @nocollapse */
ButtonComponent.ctorParameters = () => [];
ButtonComponent.propDecorators = {
    text: [{ type: Input }],
    image: [{ type: Input }],
    clicked: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ButtonComponent.prototype.text;
    /** @type {?} */
    ButtonComponent.prototype.image;
    /** @type {?} */
    ButtonComponent.prototype.clicked;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/dropdown/dropdown.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DropdownComponent {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.fullWidth = false;
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (!this.title) {
            this.title = 'Actions';
        }
        if (['default', 'primary', 'success', 'error'].indexOf(this.style) == -1) {
            console.log('TypeError: Invalid value (' + this.style
                + ') for property "style". Style value updated to "default".');
            this.style = 'default';
        }
        this.onChangesCloseList();
    }
    /**
     * @private
     * @return {?}
     */
    onChangesCloseList() {
        /** @type {?} */
        const elements = ((/** @type {?} */ (this.elementRef.nativeElement)))
            .querySelectorAll('.open');
        for (let i = 0; i < elements.length; i++) {
            elements[i].classList.remove('open');
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    toggleList(event) {
        /** @type {?} */
        const element = ((/** @type {?} */ (event.target)));
        /** @type {?} */
        const parent = element.parentElement;
        /** @type {?} */
        const target = parent.nextElementSibling;
        if (!parent.classList.contains('open')) {
            parent.classList.add('open');
            target.classList.add('open');
        }
        else {
            parent.classList.remove('open');
            target.classList.remove('open');
        }
    }
}
DropdownComponent.decorators = [
    { type: Component, args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                selector: 'sleek-dropdown',
                template: "<div [className]=\"'action_group ' + style + (fullWidth ? ' filled' : '')\">\n  <a class=\"toggle\">\n    {{ title }}\n    <i class=\"material-icons\" (click)=\"toggleList($event)\">keyboard_arrow_down</i>\n  </a>\n  <div class=\"action_group_list\">\n    <ng-content></ng-content>\n  </div>\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
DropdownComponent.ctorParameters = () => [
    { type: ElementRef }
];
DropdownComponent.propDecorators = {
    title: [{ type: Input }],
    style: [{ type: Input }],
    fullWidth: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    DropdownComponent.prototype.title;
    /** @type {?} */
    DropdownComponent.prototype.style;
    /** @type {?} */
    DropdownComponent.prototype.fullWidth;
    /**
     * @type {?}
     * @private
     */
    DropdownComponent.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/nav/nav.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NavComponent {
    constructor() {
        this.clicked = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} item
     * @return {?}
     */
    onItemClicked(item) {
        this.clicked.emit(item.link);
    }
}
NavComponent.decorators = [
    { type: Component, args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'sleek-nav',
                template: "<ng-container>\n  <nav>\n    <a *ngFor=\"let item of links\"\n       (click)=\"onItemClicked(item)\"\n       [className]=\"item.active ? 'active' : ''\">{{ item.text }}</a>\n  </nav>\n\n  <div class=\"sub-nav\">\n    <ng-container *ngFor=\"let item of links\">\n      <ng-container *ngIf=\"item.active\">\n        <a *ngFor=\"let subItem of item.child\"\n           (click)=\"onItemClicked(subItem)\"\n           [className]=\"subItem.active ? 'active' : ''\">{{ subItem.text }}</a>\n      </ng-container>\n    </ng-container>\n  </div>\n</ng-container>\n"
            }] }
];
/** @nocollapse */
NavComponent.ctorParameters = () => [];
NavComponent.propDecorators = {
    links: [{ type: Input }],
    clicked: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    NavComponent.prototype.links;
    /** @type {?} */
    NavComponent.prototype.clicked;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/date-picker/date-picker.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DatePickerComponent {
    /**
     * @param {?} cd
     */
    constructor(cd) {
        this.cd = cd;
        this.changed = new EventEmitter();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        this.updateDateSelection();
        this.years = DateService.getYears();
        this.months = DateService.getMonths();
        this.cd.markForCheck();
    }
    /**
     * @return {?}
     */
    togglePop() {
        this.isPopOpen = !this.isPopOpen;
    }
    /**
     * @param {?} year
     * @return {?}
     */
    onYearChanged(year) {
        if (this.getMinYear() <= year && year <= this.getMaxYear()) {
            this.year = year;
        }
    }
    /**
     * @param {?} month
     * @return {?}
     */
    onMonthChanged(month) {
        this.month = month;
        this.isPopOpen = false;
        this.updateDateSelection();
        this.changed.emit(new Date(this.year, month, 1));
    }
    /**
     * @param {?} name
     * @return {?}
     */
    shortMonthName(name) {
        return name.substr(0, 3);
    }
    /**
     * @return {?}
     */
    isArrowLeftDisabled() {
        return (this.year <= this.getMinYear());
    }
    /**
     * @return {?}
     */
    isArrowRightDisabled() {
        return (this.year >= this.getMaxYear());
    }
    /**
     * @private
     * @return {?}
     */
    updateDateSelection() {
        /** @type {?} */
        const monthName = DateService.getMonthName(this.month + 1);
        this.selected = monthName
            ? this.year + ' ' + this.shortMonthName(monthName) + '.'
            : '';
    }
    /**
     * @private
     * @return {?}
     */
    getMinYear() {
        return this.years[0];
    }
    /**
     * @private
     * @return {?}
     */
    getMaxYear() {
        return this.years.slice(-1)[0];
    }
}
DatePickerComponent.decorators = [
    { type: Component, args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                selector: 'sleek-date-picker',
                template: "<ng-container>\n  <div class=\"date_picker\">\n    <div [className]=\"isPopOpen ? 'date_picker_selection open' : 'date_picker_selection'\"\n         (click)=\"togglePop()\">\n      {{ selected }}\n      <span [className]=\"isPopOpen ? 'date_picker_selection_arrow open' : 'date_picker_selection_arrow'\">\n        &larr;\n      </span>\n    </div>\n\n    <div *ngIf=\"isPopOpen\" class=\"date_picker_pop\">\n      <div class=\"date_picker_year\">\n        <span class=\"date_picker_year_arrow left\"\n              [attr.disabled]=\"isArrowLeftDisabled()\"\n              (click)=\"onYearChanged(year - 1)\">&laquo;</span>\n        <span class=\"date_picker_year_active\">{{ year }}</span>\n        <span class=\"date_picker_year_arrow right\"\n              [attr.disabled]=\"isArrowRightDisabled()\"\n              (click)=\"onYearChanged(year + 1)\">&raquo;</span>\n      </div>\n\n      <div class=\"date_picker_month\">\n        <span *ngFor=\"let name of months; let i = index\"\n              [className]=\"i == month ? 'active' : ''\"\n              (click)=\"onMonthChanged(i)\">\n          {{ shortMonthName(name) }}.\n        </span>\n      </div>\n    </div>\n  </div>\n</ng-container>\n",
                styles: [".date_picker{position:relative;float:left;width:120px;margin:10px 5px 5px}.date_picker .date_picker_selection{cursor:pointer;display:block;padding:5px 10px;text-align:right;border-radius:3px;border:1px solid #999}.date_picker .date_picker_selection.open{color:#c00000;border-color:#c00000}.date_picker .date_picker_selection .date_picker_selection_arrow{display:inline-block;margin-left:10px;transform:rotate(-90deg)}.date_picker .date_picker_selection .date_picker_selection_arrow.open{transform:rotate(90deg)}.date_picker .date_picker_pop{width:200px;margin-top:5px;background-color:#fff;border:1px solid #ddd;box-shadow:1px 0 1px #c2c3c4;z-index:10;position:absolute;right:0}.date_picker .date_picker_pop .date_picker_year{text-align:center;border-bottom:1px solid #ddd}.date_picker .date_picker_pop .date_picker_year::after{clear:both;content:\"\";display:block}.date_picker .date_picker_pop .date_picker_year .date_picker_year_arrow{cursor:pointer;padding:0 10px}.date_picker .date_picker_pop .date_picker_year .date_picker_year_arrow.left{float:left}.date_picker .date_picker_pop .date_picker_year .date_picker_year_arrow.right{float:right}.date_picker .date_picker_pop .date_picker_year .date_picker_year_arrow[disabled=true]{color:#f1f1f1}.date_picker .date_picker_pop .date_picker_month span{display:inline-block;font-size:80%;padding:10px 3px;text-align:center;text-transform:uppercase;width:calc(25% - 6px);cursor:pointer}.date_picker .date_picker_pop .date_picker_month span:hover{background-color:#f1f1f1}.date_picker .date_picker_pop .date_picker_month span.active{color:#c00000;background-color:#f1f1f1}"]
            }] }
];
/** @nocollapse */
DatePickerComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
DatePickerComponent.propDecorators = {
    year: [{ type: Input }],
    month: [{ type: Input }],
    changed: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    DatePickerComponent.prototype.year;
    /** @type {?} */
    DatePickerComponent.prototype.month;
    /** @type {?} */
    DatePickerComponent.prototype.changed;
    /** @type {?} */
    DatePickerComponent.prototype.isPopOpen;
    /** @type {?} */
    DatePickerComponent.prototype.selected;
    /** @type {?} */
    DatePickerComponent.prototype.years;
    /** @type {?} */
    DatePickerComponent.prototype.months;
    /**
     * @type {?}
     * @private
     */
    DatePickerComponent.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/popup/popup.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PopupComponent {
    constructor() {
        this.close = new EventEmitter();
        if (!this.text) {
            this.text = 'Please set some text';
        }
    }
    /**
     * @return {?}
     */
    onClose() {
        this.close.emit(true);
    }
}
PopupComponent.decorators = [
    { type: Component, args: [{
                selector: 'sleek-lib-popup',
                template: "<ng-container>\n    <div class=\"popup\">\n        <div class=\"popup_content\">\n            <a *ngIf=\"closable\" (click)=\"onClose()\">close</a>\n\n            <p *ngIf=\"text\">{{ text }}</p>\n\n            <img *ngIf=\"icon\" src=\"assets/images/loading.gif\" alt=\"loading.gif\">\n\n          <ng-content></ng-content>\n        </div>\n    </div>\n</ng-container>\n",
                styles: [".popup{position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(0,0,0,.8);z-index:100}.popup .popup_content{width:400px;color:#fff;margin:5% auto;text-align:center}.popup .popup_content a{position:absolute;top:20px;right:20px;font-size:20px;color:#fff;cursor:pointer}.popup .popup_content a:hover{color:#335a9c;text-decoration:underline}.popup .popup_content p{font-size:30px;margin:20px 0}.popup .popup_content img{width:70px}"]
            }] }
];
/** @nocollapse */
PopupComponent.ctorParameters = () => [];
PopupComponent.propDecorators = {
    text: [{ type: Input }],
    icon: [{ type: Input }],
    closable: [{ type: Input }],
    close: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    PopupComponent.prototype.text;
    /** @type {?} */
    PopupComponent.prototype.icon;
    /** @type {?} */
    PopupComponent.prototype.closable;
    /** @type {?} */
    PopupComponent.prototype.close;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/chart/chart-donut/chart-donut.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ChartDonutComponent {
    constructor() {
        this.random = Math.floor(Math.random() * 1000000);
        this.colors = ['#e64c65', '#11a8ab', '#fcb150', '#4fc4f6', '#F46FDA'];
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.draw();
        }), 2000);
    }
    /**
     * @private
     * @return {?}
     */
    draw() {
        /** @type {?} */
        let canvas = document.createElement('canvas');
        /** @type {?} */
        let ctx = canvas.getContext('2d');
        /** @type {?} */
        let startAngle = 0;
        this.data.forEach((/**
         * @param {?} item
         * @param {?} index
         * @return {?}
         */
        (item, index) => {
            /** @type {?} */
            let sliceAngle = 2 * Math.PI * item.value / 100;
            ChartDonutComponent.drawPieSlice(ctx, canvas.width / 2, canvas.height / 2, Math.min(canvas.width / 2, canvas.height / 2), startAngle, startAngle + sliceAngle, this.colors[index]);
            startAngle += sliceAngle;
        }));
        ChartDonutComponent.drawPieSlice(ctx, canvas.width / 2, canvas.height / 2, 0.5 * Math.min(canvas.width / 2, canvas.height / 2), 0, 2 * Math.PI, 'transparent');
        /** @type {?} */
        let container = (/** @type {?} */ (document.querySelector('.container-' + this.random)));
        container.innerHTML = '';
        container.appendChild(canvas);
    }
    /**
     * @private
     * @param {?} ctx
     * @param {?} centerX
     * @param {?} centerY
     * @param {?} radius
     * @param {?} startAngle
     * @param {?} endAngle
     * @param {?} color
     * @return {?}
     */
    static drawPieSlice(ctx, centerX, centerY, radius, startAngle, endAngle, color) {
        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.closePath();
        ctx.fill();
    }
    /**
     * @param {?} index
     * @return {?}
     */
    getLabelStyle(index) {
        /** @type {?} */
        const color = this.colors[index] ? this.colors[index] : this.colors[0];
        return {
            width: 'calc(' + (100 / this.data.length).toFixed(2) + '% - 1px)',
            borderTop: '4px solid ' + color
        };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    getPercentage(value) {
        if (isNaN(value) || !isFinite(value)) {
            return '0%';
        }
        return value.toFixed(1) + '%';
    }
}
ChartDonutComponent.decorators = [
    { type: Component, args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                selector: 'sleek-chart-donut',
                template: "<div class=\"sleek-chart\">\n  <div [className]=\"lightMode ? 'donut-chart-block block light-mode' : 'donut-chart-block block'\">\n    <h2 class=\"titular sleek-chart-title\">{{ title }}</h2>\n\n    <div [className]=\"'donut-chart'\">\n      <div [className]=\"'container-' + random\"></div>\n\n      <p class=\"center-date\">\n        {{ info }}\n        <br>\n        <span class=\"scnd-font-color\">{{ subInfo }}</span>\n      </p>\n    </div>\n\n    <ul class=\"os-percentages horizontal-list\">\n      <li *ngFor=\"let item of data; let i = index\"\n          [ngStyle]=\"getLabelStyle(i)\">\n        <span class=\"hovered\">\n          <i>{{ getPercentage(item.value) }}</i>\n        </span>\n        <p class=\"scnd-font-color\">{{ item.label }}</p>\n        <p class=\"os-percentage\">{{ item.info }}</p>\n      </li>\n    </ul>\n  </div>\n</div>\n",
                styles: ["@charset \"UTF-8\";@font-face{font-family:\"Glyphicons Halflings\";src:url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.eot);src:url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.eot?#iefix) format(\"embedded-opentype\"),url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.woff2) format(\"woff2\"),url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.woff) format(\"woff\"),url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.ttf) format(\"truetype\"),url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.svg#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:\"Glyphicons Halflings\";font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\u20AC\"}.glyphicon-minus:before{content:\"\u2212\"}.glyphicon-cloud:before{content:\"\u2601\"}.glyphicon-envelope:before{content:\"\u2709\"}.glyphicon-pencil:before{content:\"\u270F\"}.glyphicon-glass:before{content:\"\uE001\"}.glyphicon-music:before{content:\"\uE002\"}.glyphicon-search:before{content:\"\uE003\"}.glyphicon-heart:before{content:\"\uE005\"}.glyphicon-star:before{content:\"\uE006\"}.glyphicon-star-empty:before{content:\"\uE007\"}.glyphicon-user:before{content:\"\uE008\"}.glyphicon-film:before{content:\"\uE009\"}.glyphicon-th-large:before{content:\"\uE010\"}.glyphicon-th:before{content:\"\uE011\"}.glyphicon-th-list:before{content:\"\uE012\"}.glyphicon-ok:before{content:\"\uE013\"}.glyphicon-remove:before{content:\"\uE014\"}.glyphicon-zoom-in:before{content:\"\uE015\"}.glyphicon-zoom-out:before{content:\"\uE016\"}.glyphicon-off:before{content:\"\uE017\"}.glyphicon-signal:before{content:\"\uE018\"}.glyphicon-cog:before{content:\"\uE019\"}.glyphicon-trash:before{content:\"\uE020\"}.glyphicon-home:before{content:\"\uE021\"}.glyphicon-file:before{content:\"\uE022\"}.glyphicon-time:before{content:\"\uE023\"}.glyphicon-road:before{content:\"\uE024\"}.glyphicon-download-alt:before{content:\"\uE025\"}.glyphicon-download:before{content:\"\uE026\"}.glyphicon-upload:before{content:\"\uE027\"}.glyphicon-inbox:before{content:\"\uE028\"}.glyphicon-play-circle:before{content:\"\uE029\"}.glyphicon-repeat:before{content:\"\uE030\"}.glyphicon-refresh:before{content:\"\uE031\"}.glyphicon-list-alt:before{content:\"\uE032\"}.glyphicon-lock:before{content:\"\uE033\"}.glyphicon-flag:before{content:\"\uE034\"}.glyphicon-headphones:before{content:\"\uE035\"}.glyphicon-volume-off:before{content:\"\uE036\"}.glyphicon-volume-down:before{content:\"\uE037\"}.glyphicon-volume-up:before{content:\"\uE038\"}.glyphicon-qrcode:before{content:\"\uE039\"}.glyphicon-barcode:before{content:\"\uE040\"}.glyphicon-tag:before{content:\"\uE041\"}.glyphicon-tags:before{content:\"\uE042\"}.glyphicon-book:before{content:\"\uE043\"}.glyphicon-bookmark:before{content:\"\uE044\"}.glyphicon-print:before{content:\"\uE045\"}.glyphicon-camera:before{content:\"\uE046\"}.glyphicon-font:before{content:\"\uE047\"}.glyphicon-bold:before{content:\"\uE048\"}.glyphicon-italic:before{content:\"\uE049\"}.glyphicon-text-height:before{content:\"\uE050\"}.glyphicon-text-width:before{content:\"\uE051\"}.glyphicon-align-left:before{content:\"\uE052\"}.glyphicon-align-center:before{content:\"\uE053\"}.glyphicon-align-right:before{content:\"\uE054\"}.glyphicon-align-justify:before{content:\"\uE055\"}.glyphicon-list:before{content:\"\uE056\"}.glyphicon-indent-left:before{content:\"\uE057\"}.glyphicon-indent-right:before{content:\"\uE058\"}.glyphicon-facetime-video:before{content:\"\uE059\"}.glyphicon-picture:before{content:\"\uE060\"}.glyphicon-map-marker:before{content:\"\uE062\"}.glyphicon-adjust:before{content:\"\uE063\"}.glyphicon-tint:before{content:\"\uE064\"}.glyphicon-edit:before{content:\"\uE065\"}.glyphicon-share:before{content:\"\uE066\"}.glyphicon-check:before{content:\"\uE067\"}.glyphicon-move:before{content:\"\uE068\"}.glyphicon-step-backward:before{content:\"\uE069\"}.glyphicon-fast-backward:before{content:\"\uE070\"}.glyphicon-backward:before{content:\"\uE071\"}.glyphicon-play:before{content:\"\uE072\"}.glyphicon-pause:before{content:\"\uE073\"}.glyphicon-stop:before{content:\"\uE074\"}.glyphicon-forward:before{content:\"\uE075\"}.glyphicon-fast-forward:before{content:\"\uE076\"}.glyphicon-step-forward:before{content:\"\uE077\"}.glyphicon-eject:before{content:\"\uE078\"}.glyphicon-chevron-left:before{content:\"\uE079\"}.glyphicon-chevron-right:before{content:\"\uE080\"}.glyphicon-plus-sign:before{content:\"\uE081\"}.glyphicon-minus-sign:before{content:\"\uE082\"}.glyphicon-remove-sign:before{content:\"\uE083\"}.glyphicon-ok-sign:before{content:\"\uE084\"}.glyphicon-question-sign:before{content:\"\uE085\"}.glyphicon-info-sign:before{content:\"\uE086\"}.glyphicon-screenshot:before{content:\"\uE087\"}.glyphicon-remove-circle:before{content:\"\uE088\"}.glyphicon-ok-circle:before{content:\"\uE089\"}.glyphicon-ban-circle:before{content:\"\uE090\"}.glyphicon-arrow-left:before{content:\"\uE091\"}.glyphicon-arrow-right:before{content:\"\uE092\"}.glyphicon-arrow-up:before{content:\"\uE093\"}.glyphicon-arrow-down:before{content:\"\uE094\"}.glyphicon-share-alt:before{content:\"\uE095\"}.glyphicon-resize-full:before{content:\"\uE096\"}.glyphicon-resize-small:before{content:\"\uE097\"}.glyphicon-exclamation-sign:before{content:\"\uE101\"}.glyphicon-gift:before{content:\"\uE102\"}.glyphicon-leaf:before{content:\"\uE103\"}.glyphicon-fire:before{content:\"\uE104\"}.glyphicon-eye-open:before{content:\"\uE105\"}.glyphicon-eye-close:before{content:\"\uE106\"}.glyphicon-warning-sign:before{content:\"\uE107\"}.glyphicon-plane:before{content:\"\uE108\"}.glyphicon-calendar:before{content:\"\uE109\"}.glyphicon-random:before{content:\"\uE110\"}.glyphicon-comment:before{content:\"\uE111\"}.glyphicon-magnet:before{content:\"\uE112\"}.glyphicon-chevron-up:before{content:\"\uE113\"}.glyphicon-chevron-down:before{content:\"\uE114\"}.glyphicon-retweet:before{content:\"\uE115\"}.glyphicon-shopping-cart:before{content:\"\uE116\"}.glyphicon-folder-close:before{content:\"\uE117\"}.glyphicon-folder-open:before{content:\"\uE118\"}.glyphicon-resize-vertical:before{content:\"\uE119\"}.glyphicon-resize-horizontal:before{content:\"\uE120\"}.glyphicon-hdd:before{content:\"\uE121\"}.glyphicon-bullhorn:before{content:\"\uE122\"}.glyphicon-bell:before{content:\"\uE123\"}.glyphicon-certificate:before{content:\"\uE124\"}.glyphicon-thumbs-up:before{content:\"\uE125\"}.glyphicon-thumbs-down:before{content:\"\uE126\"}.glyphicon-hand-right:before{content:\"\uE127\"}.glyphicon-hand-left:before{content:\"\uE128\"}.glyphicon-hand-up:before{content:\"\uE129\"}.glyphicon-hand-down:before{content:\"\uE130\"}.glyphicon-circle-arrow-right:before{content:\"\uE131\"}.glyphicon-circle-arrow-left:before{content:\"\uE132\"}.glyphicon-circle-arrow-up:before{content:\"\uE133\"}.glyphicon-circle-arrow-down:before{content:\"\uE134\"}.glyphicon-globe:before{content:\"\uE135\"}.glyphicon-wrench:before{content:\"\uE136\"}.glyphicon-tasks:before{content:\"\uE137\"}.glyphicon-filter:before{content:\"\uE138\"}.glyphicon-briefcase:before{content:\"\uE139\"}.glyphicon-fullscreen:before{content:\"\uE140\"}.glyphicon-dashboard:before{content:\"\uE141\"}.glyphicon-paperclip:before{content:\"\uE142\"}.glyphicon-heart-empty:before{content:\"\uE143\"}.glyphicon-link:before{content:\"\uE144\"}.glyphicon-phone:before{content:\"\uE145\"}.glyphicon-pushpin:before{content:\"\uE146\"}.glyphicon-usd:before{content:\"\uE148\"}.glyphicon-gbp:before{content:\"\uE149\"}.glyphicon-sort:before{content:\"\uE150\"}.glyphicon-sort-by-alphabet:before{content:\"\uE151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\uE152\"}.glyphicon-sort-by-order:before{content:\"\uE153\"}.glyphicon-sort-by-order-alt:before{content:\"\uE154\"}.glyphicon-sort-by-attributes:before{content:\"\uE155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\uE156\"}.glyphicon-unchecked:before{content:\"\uE157\"}.glyphicon-expand:before{content:\"\uE158\"}.glyphicon-collapse-down:before{content:\"\uE159\"}.glyphicon-collapse-up:before{content:\"\uE160\"}.glyphicon-log-in:before{content:\"\uE161\"}.glyphicon-flash:before{content:\"\uE162\"}.glyphicon-log-out:before{content:\"\uE163\"}.glyphicon-new-window:before{content:\"\uE164\"}.glyphicon-record:before{content:\"\uE165\"}.glyphicon-save:before{content:\"\uE166\"}.glyphicon-open:before{content:\"\uE167\"}.glyphicon-saved:before{content:\"\uE168\"}.glyphicon-import:before{content:\"\uE169\"}.glyphicon-export:before{content:\"\uE170\"}.glyphicon-send:before{content:\"\uE171\"}.glyphicon-floppy-disk:before{content:\"\uE172\"}.glyphicon-floppy-saved:before{content:\"\uE173\"}.glyphicon-floppy-remove:before{content:\"\uE174\"}.glyphicon-floppy-save:before{content:\"\uE175\"}.glyphicon-floppy-open:before{content:\"\uE176\"}.glyphicon-credit-card:before{content:\"\uE177\"}.glyphicon-transfer:before{content:\"\uE178\"}.glyphicon-cutlery:before{content:\"\uE179\"}.glyphicon-header:before{content:\"\uE180\"}.glyphicon-compressed:before{content:\"\uE181\"}.glyphicon-earphone:before{content:\"\uE182\"}.glyphicon-phone-alt:before{content:\"\uE183\"}.glyphicon-tower:before{content:\"\uE184\"}.glyphicon-stats:before{content:\"\uE185\"}.glyphicon-sd-video:before{content:\"\uE186\"}.glyphicon-hd-video:before{content:\"\uE187\"}.glyphicon-subtitles:before{content:\"\uE188\"}.glyphicon-sound-stereo:before{content:\"\uE189\"}.glyphicon-sound-dolby:before{content:\"\uE190\"}.glyphicon-sound-5-1:before{content:\"\uE191\"}.glyphicon-sound-6-1:before{content:\"\uE192\"}.glyphicon-sound-7-1:before{content:\"\uE193\"}.glyphicon-copyright-mark:before{content:\"\uE194\"}.glyphicon-registration-mark:before{content:\"\uE195\"}.glyphicon-cloud-download:before{content:\"\uE197\"}.glyphicon-cloud-upload:before{content:\"\uE198\"}.glyphicon-tree-conifer:before{content:\"\uE199\"}.glyphicon-tree-deciduous:before{content:\"\uE200\"}.glyphicon-cd:before{content:\"\uE201\"}.glyphicon-save-file:before{content:\"\uE202\"}.glyphicon-open-file:before{content:\"\uE203\"}.glyphicon-level-up:before{content:\"\uE204\"}.glyphicon-copy:before{content:\"\uE205\"}.glyphicon-paste:before{content:\"\uE206\"}.glyphicon-alert:before{content:\"\uE209\"}.glyphicon-equalizer:before{content:\"\uE210\"}.glyphicon-king:before{content:\"\uE211\"}.glyphicon-queen:before{content:\"\uE212\"}.glyphicon-pawn:before{content:\"\uE213\"}.glyphicon-bishop:before{content:\"\uE214\"}.glyphicon-knight:before{content:\"\uE215\"}.glyphicon-baby-formula:before{content:\"\uE216\"}.glyphicon-tent:before{content:\"\u26FA\"}.glyphicon-blackboard:before{content:\"\uE218\"}.glyphicon-bed:before{content:\"\uE219\"}.glyphicon-apple:before{content:\"\uF8FF\"}.glyphicon-erase:before{content:\"\uE221\"}.glyphicon-hourglass:before{content:\"\u231B\"}.glyphicon-lamp:before{content:\"\uE223\"}.glyphicon-duplicate:before{content:\"\uE224\"}.glyphicon-piggy-bank:before{content:\"\uE225\"}.glyphicon-scissors:before{content:\"\uE226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\uE227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\u00A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\u20BD\"}.glyphicon-scale:before{content:\"\uE230\"}.glyphicon-ice-lolly:before{content:\"\uE231\"}.glyphicon-ice-lolly-tasted:before{content:\"\uE232\"}.glyphicon-education:before{content:\"\uE233\"}.glyphicon-option-horizontal:before{content:\"\uE234\"}.glyphicon-option-vertical:before{content:\"\uE235\"}.glyphicon-menu-hamburger:before{content:\"\uE236\"}.glyphicon-modal-window:before{content:\"\uE237\"}.glyphicon-oil:before{content:\"\uE238\"}.glyphicon-grain:before{content:\"\uE239\"}.glyphicon-sunglasses:before{content:\"\uE240\"}.glyphicon-text-size:before{content:\"\uE241\"}.glyphicon-text-color:before{content:\"\uE242\"}.glyphicon-text-background:before{content:\"\uE243\"}.glyphicon-object-align-top:before{content:\"\uE244\"}.glyphicon-object-align-bottom:before{content:\"\uE245\"}.glyphicon-object-align-horizontal:before{content:\"\uE246\"}.glyphicon-object-align-left:before{content:\"\uE247\"}.glyphicon-object-align-vertical:before{content:\"\uE248\"}.glyphicon-object-align-right:before{content:\"\uE249\"}.glyphicon-triangle-right:before{content:\"\uE250\"}.glyphicon-triangle-left:before{content:\"\uE251\"}.glyphicon-triangle-bottom:before{content:\"\uE252\"}.glyphicon-triangle-top:before{content:\"\uE253\"}.glyphicon-console:before{content:\"\uE254\"}.glyphicon-superscript:before{content:\"\uE255\"}.glyphicon-subscript:before{content:\"\uE256\"}.glyphicon-menu-left:before{content:\"\uE257\"}.glyphicon-menu-right:before{content:\"\uE258\"}.glyphicon-menu-down:before{content:\"\uE259\"}.glyphicon-menu-up:before{content:\"\uE260\"}.sel{font-size:.7rem;display:inline-block;margin:10px 0;width:120px;background-color:transparent;border-bottom:4px solid rgba(0,0,0,.3);position:relative;cursor:pointer}.sel.large{width:200px}.sel.xlarge{width:400px}.sel.auto{width:50%;min-width:200px}.sel::before{position:absolute;content:\"\uF063\";font-family:FontAwesome;font-size:2em;color:#1e9df8;right:20px;top:calc(50% - .5em)}.sel.active::before{transform:rotateX(-180deg)}.sel__placeholder{display:block;font-family:Quicksand;font-size:2.3em;color:#1e9df8;padding:.2em .5em;text-align:left;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;visibility:visible}.sel.active .sel__placeholder{visibility:hidden}.sel__placeholder::before{position:absolute;top:0;bottom:0;left:0;right:0;padding:.2em .5em;content:attr(data-placeholder);visibility:hidden}.sel.active .sel__placeholder::before{visibility:visible}.sel__box{position:absolute;top:calc(100% + 4px);left:-4px;display:none;list-style-type:none;text-align:left;font-size:1em;background-color:#fff;width:calc(100% + 8px);box-sizing:border-box}.sel.active .sel__box{display:block;-webkit-animation:.5s fadeInUp;animation:.5s fadeInUp}.sel__box__options{display:list-item;font-family:Quicksand;font-size:1.5em;color:#838e95;padding:.5em 1em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.sel__box__options.disabled{color:#63b175;font-size:1.1em;padding-top:10px;padding-bottom:10px;background-color:#e9e9e9;text-transform:uppercase;cursor:text}.sel__box__options.selected{color:#1e9df8}.sel__box__options::after{content:\"\uF00C\";font-family:FontAwesome;font-size:.5em;margin-left:5px;display:none}.sel__box__options.selected::after{display:inline}.sel__box__options:hover{background-color:#ebedef}@-webkit-keyframes fadeInUp{from{opacity:0;transform:translate3d(0,20px,0)}to{opacity:1;transform:none}}@keyframes fadeInUp{from{opacity:0;transform:translate3d(0,20px,0)}to{opacity:1;transform:none}}@-webkit-keyframes fadeOut{from{opacity:1}to{opacity:0}}@keyframes fadeOut{from{opacity:1}to{opacity:0}}.row:after{clear:both;content:\"\";display:block}.row .col{float:left}.row .col:not(:first-child){margin-left:1%!important}.row .col-md-3{width:24%}.row .col-md-4{width:32%}.row .col-md-6{width:49%}.row .col-md-8{width:64%}.row .col-md-9{width:74%}.row .col-md-12{width:100%;margin-left:0}.form-group .col{margin:8px 0}.card{color:#555;padding:20px 0;background-color:#fff;border-radius:5px}.card .card_img{width:100px;margin:0 auto}.card .card_content{margin-top:10px;padding:5px 20px;border-top:1px solid #e5e5e5}.card .card_content .card_line span{display:inline-block;padding:5px 0}.card .card_content .card_line span.key{width:30%;text-align:right;color:#999}.card .card_content .card_line span.value{width:calc(70% - 20px);text-align:left;padding-left:20px}*{margin:0;padding:0}body{color:#555;font-size:16px;font-family:\"EB Garamond\",serif;background-color:#f9f9f9}a{color:#335a9c;text-decoration:none}a:hover{text-decoration:underline}.container{width:90%;max-width:940px;min-width:340px;margin:0 auto}.clearfix{clear:both}.clickable{cursor:pointer}.page{padding:10px 0;background-color:#fff;box-shadow:0 1px 1px #ddd}.page>div{margin:0 30px}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert.alert-primary{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.btn{padding:9px 10px;color:#000;background-color:transparent;border:1px solid #999;border-radius:3px;cursor:pointer}.btn.btn-sm{font-size:70%;padding:3px 10px}.btn:hover{background-color:transparent}.btn.btn-danger{color:#fff;background-color:#c00000;border-color:#c00000}.btn.btn-danger:hover{color:#c00000;background-color:#fff}.btn.btn-primary{color:#fff;background-color:#335a9c;border-color:#335a9c}.btn.btn-primary:hover{color:#335a9c;background-color:#fff}.btn.btn-primary:disabled{color:#fff;background-color:rgba(51,90,156,.5);border-color:transparent}.btn.btn-success{color:#fff;background-color:#63b175;border-color:#63b175}.btn.btn-success:hover{color:#63b175;background-color:#fff}.btn.btn-success:disabled{color:#fff;background-color:rgba(99,177,117,.5);border-color:transparent}.btn.btn-secondary{color:#888;background-color:#f1f1f1;border-color:#c2c3c4}.btn.btn-secondary:hover{color:#888;background-color:#f9f9f9}.btn.btn-image{font-size:10px;padding:3px 8px 3px 1px;border-color:#335a9c;text-decoration:none}.btn.btn-image:hover{color:#335a9c;background-color:rgba(240,240,240,.9);text-decoration:none}.btn.btn-image i{display:inline-block;vertical-align:middle}.filter .sel:not(:first-child){margin-left:20px}.form label{display:block;margin-bottom:10px}.form label input,.form label textarea{width:calc(100% - 10px);display:block;margin-top:5px;padding:3px 5px;border:1px solid #ddd;border-radius:3px}.form label input{height:30px}.form label textarea{height:50px}.form button{padding:10px;color:#63b175;border:1px solid #335a9c;border-radius:3px;cursor:pointer}.form button:hover{color:#fff;background-color:#335a9c}.form .form-separator{color:#335a9c;font-size:80%;padding-bottom:5px;margin:30px 0 10px;text-transform:uppercase;border-bottom:1px solid #335a9c}.form-control:disabled{background-color:#eee;cursor:text}h3.title{font-size:30px;margin-bottom:20px}h3.title a{font-size:13px;margin-top:15px;display:inline-block;color:#335a9c;text-decoration:none;text-transform:uppercase}h3.title a:hover{text-decoration:underline}.hidden{display:none!important}.nowrap{white-space:nowrap}.pagination{text-align:right}.pagination a{color:#fff;margin:0 5px;padding:5px 15px;text-align:center;display:inline-block;background-color:#335a9c;cursor:pointer}.pagination a.active,.pagination a:hover{background-color:#335a9c}.pagination a.disabled{background-color:rgba(51,90,156,.5);text-decoration:none;cursor:text}.pull-right{float:right}.table{width:100%;border-collapse:collapse}.table td,.table th{padding:10px}.table thead th{text-align:left;border-bottom:1px solid #777}.table tbody tr:nth-child(odd) td{background-color:#f5f5f5}.table tbody tr:not(:first-child) td{border-top:1px solid #fff}.table tbody tr td.actions{width:100px;text-align:center}.table tbody tr td.actions.small{width:50px}.table tbody tr td.actions i{font-size:120%;display:inline-block;vertical-align:middle;cursor:pointer}.table tbody tr td.actions i:not(:first-child){margin-left:10px}.table tbody tr td.actions i:first-child{color:#63b175}.table tbody tr td.actions i:nth-child(2){color:#335a9c}.table tbody tr td.actions i:last-child{color:#c00000}.table tbody tr td.actions i:hover{color:#335a9c}.table tbody tr td img{width:20px;cursor:pointer}.table tbody tr td img:not(:first-child){margin-left:10px}.table tbody tr td img.avatar{width:30px}.table tbody tr td .story,.table tbody tr td a{color:#335a9c}.table tbody tr .text-small{font-size:11px}.table tfoot tr td{border-top:1px solid #777}.table.table-small td{padding-top:5px;padding-bottom:5px}.table.stripped tr:nth-child(odd) td{background-color:#fff}.table.stripped tr td:not(:first-child){border-left:1px solid #fff}.table.stripped tr td.icon-holder{text-align:center;vertical-align:middle}.table.stripped tr td.icon-holder .cash-icon{width:20px}.text-center{text-align:center!important}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-bold{font-weight:600}.text-blue{color:#335a9c!important}.text-gray{color:#888!important}.text-green{color:#63b175!important}.text-red{color:#c00000!important}.text-muted{color:#999}.text-small{font-size:80%}.text-uppercase{text-transform:uppercase}.text-no-break{white-space:nowrap}.text-ellipsis{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.modal{position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(0,0,0,.7)}.modal .modal-content{width:80%;max-width:500px;margin:20px auto;background-color:#fff;border-radius:3px}.modal .modal-content>*{padding:10px 20px}.modal .modal-content .modal-head{font-weight:700;color:#335a9c;text-transform:uppercase;border-bottom:1px solid #999}.modal .modal-content .modal-body{padding-top:20px}.modal .modal-content .modal-body .form-group label:not(:first-child){margin-top:0}.modal .modal-content .modal-body .btn-group{text-align:right}.btn-group{margin-top:20px}.btn-group .btn{display:inline-block;text-transform:uppercase}.btn-group .btn:not(.btn-sm){padding:6px 10px}.btn-group .btn:not(:first-child){margin-left:10px}.btn-group .btn.btn-cancel{color:#555;border-color:#ebedef}.btn-group .btn.btn-cancel:hover{color:#999;border-color:#999}.btn-group .btn.btn-apply{color:#fff;background-color:#63b175;border-color:#63b175}.btn-group .btn.btn-apply:hover{opacity:.6}.btn-group .btn.btn-apply:disabled{color:#555;background-color:#ebedef;border-color:#ebedef}.btn-group .btn.btn-delete{color:#fff;background-color:#c00000;border-color:#c00000}.btn-group .btn.btn-delete:hover{opacity:.6}.form-group label{display:block}.form-group label:not(:first-child){margin-top:10px}.form-group label[class^=col-].mgn-lt{margin-left:10px}.form-group label.labeled input{margin-top:5px}.form-group label>span{display:block;padding:5px 0;color:#555;text-transform:capitalize}.form-group label .radio span{padding:5px 10px;width:calc(49% - 22px);display:inline-block;text-align:center;border:1px solid #999;border-radius:3px;text-transform:capitalize;cursor:pointer}.form-group label .radio span:last-child{margin-left:2%}.form-group label .radio span:hover{color:#335a9c;border-color:#335a9c}.form-group label .radio span.active{color:#fff;background-color:#335a9c;border-color:#335a9c}.form-group .form-control{padding:8px 10px;width:calc(100% - 20px);border:1px solid #999;border-radius:3px}.form-group select.form-control{width:100%}.form-group select.form-control.no_fill{width:auto;min-width:100px}.form-group select.form-control.no_fill:not(:first-child){margin-left:10px}header{min-height:100px;position:relative;background-color:#fff}header .logo_holder{position:absolute;top:0;left:0;padding:20px 0 0 30px}header .logo_holder img{width:150px;display:block}header .logo_holder span{color:#335a9c;font-size:14px;text-transform:uppercase}header .content-user{position:absolute;top:30px;right:0;height:60px;background-color:#fff}header .content-user span{position:absolute;top:10px;right:80px;text-align:right;white-space:nowrap}header .content-user span a{color:#335a9c}header .content-user span small{display:block}header .content-user img{position:absolute;top:10px;right:30px;width:40px;height:40px}header nav{background-color:#394264}header nav a{width:90px;padding:7px 15px;margin-left:10px;margin-bottom:5px;text-align:center;display:inline-block;color:#fff;cursor:pointer;border-bottom:3px solid #fff}header nav a.active{border-color:#e64c65}header nav a:hover{border-color:#e64c65;color:#e64c65;text-decoration:none}header .sub-nav{background-color:#f1f1f1}header .sub-nav a{width:90px;margin-top:2px;margin-left:10px;margin-bottom:5px;padding:7px 15px;color:#777;text-align:center;display:inline-block;border-bottom:3px solid #777;cursor:pointer}header .sub-nav a:hover{color:#63b175;border-color:#63b175;text-decoration:none}header .sub-nav a.active{color:#e64c65;border-color:#e64c65}footer{margin:20px 30px;text-align:right}.bubble{padding:8px;display:inline-block;background-color:#f1f1f1;border-radius:8px}.bubble.green{background-color:#63b175}.bubble.red{background-color:#c00000}.sleek-chart .block{background-color:#394264;border-radius:5px;box-shadow:0 1px 1px 0;margin:0 20px 20px 0;width:100%;float:left;overflow:hidden}.sleek-chart .block.light-mode{background:#f3f3f3}.sleek-chart .block.light-mode .sleek-chart-legend div:not(.comparative),.sleek-chart .block.light-mode .sleek-chart-title{color:#394264}.sleek-chart .block.light-mode .sleek-chart-legend div:not(.comparative) span{background-color:#394264}.sleek-chart .block.light-mode .sleek-chart-draw #sleekChartLineDraw .line_container .line_container_item .hovered p:not(.comparative),.sleek-chart .block.light-mode .sleek-chart-draw #sleekChartLineDraw .line_container .line_container_item span{color:#394264}.sleek-chart .block.light-mode .sleek-chart-draw #sleekChartLineDraw .line_container .line_container_item span:not(.comparative){background-color:#394264}.sleek-chart .block.light-mode .sleek-chart-draw #sleekChartLineDraw .label_container span{color:#1f253d}.sleek-chart .block.light-mode .horizontal-list li{background-color:#e7e7e7;border-color:#c2c3c4}.sleek-chart .block.light-mode .horizontal-list li span{color:#394264}.sleek-chart .block.light-mode .horizontal-list li p.scnd-font-color{color:#1f253d}.sleek-chart .block.light-mode .horizontal-list li p.os-percentage,.sleek-chart .block.light-mode .sleek-chart-info{color:#394264}.sleek-chart{box-sizing:border-box}.sleek-chart ul{list-style-type:none;margin:0;padding-left:0}.sleek-chart h1{font-size:1.8em}.sleek-chart h2{font-size:1.4em}.sleek-chart p{font-size:15px}.sleek-chart a{text-decoration:none;font-size:15px}.sleek-chart a:hover{text-decoration:underline}.sleek-chart a,.sleek-chart h1,.sleek-chart h2,.sleek-chart p,.sleek-chart span{color:#fff}.sleek-chart .scnd-font-color{color:#9099b7}.sleek-chart .titular{display:block;line-height:60px;margin:0;text-align:center;text-transform:uppercase;border-top-left-radius:5px;border-top-right-radius:5px}.sleek-chart .horizontal-list{margin:0;padding:0;list-style-type:none}.sleek-chart .horizontal-list li{float:left}.sleek-chart .donut-chart-block{min-width:400px;min-height:380px;overflow:hidden}.sleek-chart .donut-chart-block .titular{padding:10px 0}.sleek-chart .os-percentages li{width:calc(20% - 1px);text-align:center;background-color:#50597b;border-left:1px solid #394264;position:relative}.sleek-chart .os-percentages li span.hovered{display:none;position:absolute;top:-25px;left:0;width:100%}.sleek-chart .os-percentages li span.hovered i{display:block;font-style:normal;padding-bottom:5px;text-align:center}.sleek-chart .os-percentages li:hover span.hovered{display:block}.sleek-chart .os-percentages li p{margin:0;padding:10px 5px 5px;font-size:15px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.sleek-chart .os-percentages li p.os-percentage{margin:0;padding:0 0 15px 10px;font-size:25px}.sleek-chart .donut-chart{position:relative;width:200px;height:200px;margin:0 auto 2rem;border-radius:100%}.sleek-chart .donut-chart div[class^=container-]{text-align:center;position:relative}.sleek-chart .donut-chart canvas{height:200px;position:absolute;left:-100px}.sleek-chart p.center-date{background:#394264;position:absolute;text-align:center;font-size:28px;top:0;left:0;bottom:0;right:0;width:130px;height:100px;margin:auto;border-radius:50%;line-height:35px;padding:15% 0 0}.sleek-chart .center-date span.scnd-font-color{line-height:0}"]
            }] }
];
ChartDonutComponent.propDecorators = {
    title: [{ type: Input }],
    info: [{ type: Input }],
    subInfo: [{ type: Input }],
    data: [{ type: Input }],
    lightMode: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ChartDonutComponent.prototype.title;
    /** @type {?} */
    ChartDonutComponent.prototype.info;
    /** @type {?} */
    ChartDonutComponent.prototype.subInfo;
    /** @type {?} */
    ChartDonutComponent.prototype.data;
    /** @type {?} */
    ChartDonutComponent.prototype.lightMode;
    /** @type {?} */
    ChartDonutComponent.prototype.random;
    /**
     * @type {?}
     * @private
     */
    ChartDonutComponent.prototype.colors;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/chart/chart-line/chart-line.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ChartLineComponent {
    /**
     * @param {?} _cd
     */
    constructor(_cd) {
        this._cd = _cd;
        this.colors = Color.getList();
        this.maxHeight = 150;
        this.maxValue = 0;
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        this.draw();
        this._cd.markForCheck();
    }
    /**
     * @private
     * @return {?}
     */
    draw() {
        this.data.forEach((/**
         * @param {?} item
         * @return {?}
         */
        item => {
            if (item.value > this.maxValue) {
                this.maxValue = item.value;
            }
            if (item.comparativeValue && item.comparativeValue > this.maxValue) {
                this.maxValue = item.comparativeValue;
            }
        }));
    }
    /**
     * @param {?} line
     * @return {?}
     */
    shouldCompare(line) {
        return (typeof line.comparativeValue == 'number');
    }
    /**
     * @param {?} line
     * @param {?} compare
     * @return {?}
     */
    getLineStyle(line, compare) {
        /** @type {?} */
        const value = !compare ? line.value : line.comparativeValue;
        /** @type {?} */
        const heightRatio = (value >= this.maxValue) ? 1 : (value / this.maxValue);
        return {
            height: (heightRatio * this.maxHeight) + 'px'
        };
    }
    /**
     * @param {?} index
     * @return {?}
     */
    getLabelStyle(index) {
        /** @type {?} */
        const color = this.colors[index] ? this.colors[index] : this.colors[0];
        return {
            width: this.getColumnWidth(),
            fontSize: (this.data.length > 8) ? '70%' : 'inherit',
            borderTop: '4px solid ' + color,
        };
    }
    /**
     * @return {?}
     */
    getColumnWidth() {
        return 'calc(' + (100 / this.data.length).toFixed(2) + '% - 1px)';
    }
}
ChartLineComponent.decorators = [
    { type: Component, args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                selector: 'sleek-chart-line',
                template: "<div class=\"sleek-chart\">\n  <div [className]=\"lightMode ? 'block light-mode' : 'block'\">\n    <div class=\"sleek-chart-title text-center\">\n      {{ title }}\n    </div>\n\n    <div class=\"sleek-chart-legend text-center\">\n      <div>\n        <span></span> {{ valueText }}\n      </div>\n      <div *ngIf=\"comparativeValueText\" class=\"comparative\">\n        <span></span> {{ comparativeValueText }}\n      </div>\n    </div>\n\n    <div class=\"sleek-chart-draw\">\n      <div id=\"sleekChartLineDraw\">\n        <div class=\"line_container\">\n          <div *ngFor=\"let item of data\"\n               [ngStyle]=\"{ 'width': getColumnWidth() }\"\n               class=\"line_container_item\">\n            <div class=\"hovered\">\n              <p>{{ item.value | number:'1.0-0':'en' }}</p>\n              <p *ngIf=\"shouldCompare(item)\"\n                 class=\"comparative\">{{ item.comparativeValue | number:'1.0-0':'en' }}</p>\n            </div>\n\n            <span [ngStyle]=\"getLineStyle(item, false)\"></span>\n            <span *ngIf=\"shouldCompare(item)\"\n                  class=\"comparative\"\n                  [ngStyle]=\"getLineStyle(item, true)\"></span>\n          </div>\n        </div>\n\n        <div class=\"label_container\">\n        <span *ngFor=\"let item of data; let i = index\"\n              [ngStyle]=\"getLabelStyle(i)\">{{ item.label }}</span>\n        </div>\n      </div>\n    </div>\n\n    <div *ngIf=\"info\"\n         class=\"sleek-chart-info text-center\">{{ info }}</div>\n  </div>\n</div>\n",
                styles: ["@charset \"UTF-8\";@font-face{font-family:\"Glyphicons Halflings\";src:url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.eot);src:url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.eot?#iefix) format(\"embedded-opentype\"),url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.woff2) format(\"woff2\"),url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.woff) format(\"woff\"),url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.ttf) format(\"truetype\"),url(projects/commons/src/lib/assets/fonts/glyphicons-halflings-regular.svg#glyphicons_halflingsregular) format(\"svg\")}@-webkit-keyframes fadeInUp{from{opacity:0;transform:translate3d(0,20px,0)}to{opacity:1;transform:none}}@-webkit-keyframes fadeOut{from{opacity:1}to{opacity:0}}.glyphicon{position:relative;top:1px;display:inline-block;font-family:\"Glyphicons Halflings\";font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\u20AC\"}.glyphicon-minus:before{content:\"\u2212\"}.glyphicon-cloud:before{content:\"\u2601\"}.glyphicon-envelope:before{content:\"\u2709\"}.glyphicon-pencil:before{content:\"\u270F\"}.glyphicon-glass:before{content:\"\uE001\"}.glyphicon-music:before{content:\"\uE002\"}.glyphicon-search:before{content:\"\uE003\"}.glyphicon-heart:before{content:\"\uE005\"}.glyphicon-star:before{content:\"\uE006\"}.glyphicon-star-empty:before{content:\"\uE007\"}.glyphicon-user:before{content:\"\uE008\"}.glyphicon-film:before{content:\"\uE009\"}.glyphicon-th-large:before{content:\"\uE010\"}.glyphicon-th:before{content:\"\uE011\"}.glyphicon-th-list:before{content:\"\uE012\"}.glyphicon-ok:before{content:\"\uE013\"}.glyphicon-remove:before{content:\"\uE014\"}.glyphicon-zoom-in:before{content:\"\uE015\"}.glyphicon-zoom-out:before{content:\"\uE016\"}.glyphicon-off:before{content:\"\uE017\"}.glyphicon-signal:before{content:\"\uE018\"}.glyphicon-cog:before{content:\"\uE019\"}.glyphicon-trash:before{content:\"\uE020\"}.glyphicon-home:before{content:\"\uE021\"}.glyphicon-file:before{content:\"\uE022\"}.glyphicon-time:before{content:\"\uE023\"}.glyphicon-road:before{content:\"\uE024\"}.glyphicon-download-alt:before{content:\"\uE025\"}.glyphicon-download:before{content:\"\uE026\"}.glyphicon-upload:before{content:\"\uE027\"}.glyphicon-inbox:before{content:\"\uE028\"}.glyphicon-play-circle:before{content:\"\uE029\"}.glyphicon-repeat:before{content:\"\uE030\"}.glyphicon-refresh:before{content:\"\uE031\"}.glyphicon-list-alt:before{content:\"\uE032\"}.glyphicon-lock:before{content:\"\uE033\"}.glyphicon-flag:before{content:\"\uE034\"}.glyphicon-headphones:before{content:\"\uE035\"}.glyphicon-volume-off:before{content:\"\uE036\"}.glyphicon-volume-down:before{content:\"\uE037\"}.glyphicon-volume-up:before{content:\"\uE038\"}.glyphicon-qrcode:before{content:\"\uE039\"}.glyphicon-barcode:before{content:\"\uE040\"}.glyphicon-tag:before{content:\"\uE041\"}.glyphicon-tags:before{content:\"\uE042\"}.glyphicon-book:before{content:\"\uE043\"}.glyphicon-bookmark:before{content:\"\uE044\"}.glyphicon-print:before{content:\"\uE045\"}.glyphicon-camera:before{content:\"\uE046\"}.glyphicon-font:before{content:\"\uE047\"}.glyphicon-bold:before{content:\"\uE048\"}.glyphicon-italic:before{content:\"\uE049\"}.glyphicon-text-height:before{content:\"\uE050\"}.glyphicon-text-width:before{content:\"\uE051\"}.glyphicon-align-left:before{content:\"\uE052\"}.glyphicon-align-center:before{content:\"\uE053\"}.glyphicon-align-right:before{content:\"\uE054\"}.glyphicon-align-justify:before{content:\"\uE055\"}.glyphicon-list:before{content:\"\uE056\"}.glyphicon-indent-left:before{content:\"\uE057\"}.glyphicon-indent-right:before{content:\"\uE058\"}.glyphicon-facetime-video:before{content:\"\uE059\"}.glyphicon-picture:before{content:\"\uE060\"}.glyphicon-map-marker:before{content:\"\uE062\"}.glyphicon-adjust:before{content:\"\uE063\"}.glyphicon-tint:before{content:\"\uE064\"}.glyphicon-edit:before{content:\"\uE065\"}.glyphicon-share:before{content:\"\uE066\"}.glyphicon-check:before{content:\"\uE067\"}.glyphicon-move:before{content:\"\uE068\"}.glyphicon-step-backward:before{content:\"\uE069\"}.glyphicon-fast-backward:before{content:\"\uE070\"}.glyphicon-backward:before{content:\"\uE071\"}.glyphicon-play:before{content:\"\uE072\"}.glyphicon-pause:before{content:\"\uE073\"}.glyphicon-stop:before{content:\"\uE074\"}.glyphicon-forward:before{content:\"\uE075\"}.glyphicon-fast-forward:before{content:\"\uE076\"}.glyphicon-step-forward:before{content:\"\uE077\"}.glyphicon-eject:before{content:\"\uE078\"}.glyphicon-chevron-left:before{content:\"\uE079\"}.glyphicon-chevron-right:before{content:\"\uE080\"}.glyphicon-plus-sign:before{content:\"\uE081\"}.glyphicon-minus-sign:before{content:\"\uE082\"}.glyphicon-remove-sign:before{content:\"\uE083\"}.glyphicon-ok-sign:before{content:\"\uE084\"}.glyphicon-question-sign:before{content:\"\uE085\"}.glyphicon-info-sign:before{content:\"\uE086\"}.glyphicon-screenshot:before{content:\"\uE087\"}.glyphicon-remove-circle:before{content:\"\uE088\"}.glyphicon-ok-circle:before{content:\"\uE089\"}.glyphicon-ban-circle:before{content:\"\uE090\"}.glyphicon-arrow-left:before{content:\"\uE091\"}.glyphicon-arrow-right:before{content:\"\uE092\"}.glyphicon-arrow-up:before{content:\"\uE093\"}.glyphicon-arrow-down:before{content:\"\uE094\"}.glyphicon-share-alt:before{content:\"\uE095\"}.glyphicon-resize-full:before{content:\"\uE096\"}.glyphicon-resize-small:before{content:\"\uE097\"}.glyphicon-exclamation-sign:before{content:\"\uE101\"}.glyphicon-gift:before{content:\"\uE102\"}.glyphicon-leaf:before{content:\"\uE103\"}.glyphicon-fire:before{content:\"\uE104\"}.glyphicon-eye-open:before{content:\"\uE105\"}.glyphicon-eye-close:before{content:\"\uE106\"}.glyphicon-warning-sign:before{content:\"\uE107\"}.glyphicon-plane:before{content:\"\uE108\"}.glyphicon-calendar:before{content:\"\uE109\"}.glyphicon-random:before{content:\"\uE110\"}.glyphicon-comment:before{content:\"\uE111\"}.glyphicon-magnet:before{content:\"\uE112\"}.glyphicon-chevron-up:before{content:\"\uE113\"}.glyphicon-chevron-down:before{content:\"\uE114\"}.glyphicon-retweet:before{content:\"\uE115\"}.glyphicon-shopping-cart:before{content:\"\uE116\"}.glyphicon-folder-close:before{content:\"\uE117\"}.glyphicon-folder-open:before{content:\"\uE118\"}.glyphicon-resize-vertical:before{content:\"\uE119\"}.glyphicon-resize-horizontal:before{content:\"\uE120\"}.glyphicon-hdd:before{content:\"\uE121\"}.glyphicon-bullhorn:before{content:\"\uE122\"}.glyphicon-bell:before{content:\"\uE123\"}.glyphicon-certificate:before{content:\"\uE124\"}.glyphicon-thumbs-up:before{content:\"\uE125\"}.glyphicon-thumbs-down:before{content:\"\uE126\"}.glyphicon-hand-right:before{content:\"\uE127\"}.glyphicon-hand-left:before{content:\"\uE128\"}.glyphicon-hand-up:before{content:\"\uE129\"}.glyphicon-hand-down:before{content:\"\uE130\"}.glyphicon-circle-arrow-right:before{content:\"\uE131\"}.glyphicon-circle-arrow-left:before{content:\"\uE132\"}.glyphicon-circle-arrow-up:before{content:\"\uE133\"}.glyphicon-circle-arrow-down:before{content:\"\uE134\"}.glyphicon-globe:before{content:\"\uE135\"}.glyphicon-wrench:before{content:\"\uE136\"}.glyphicon-tasks:before{content:\"\uE137\"}.glyphicon-filter:before{content:\"\uE138\"}.glyphicon-briefcase:before{content:\"\uE139\"}.glyphicon-fullscreen:before{content:\"\uE140\"}.glyphicon-dashboard:before{content:\"\uE141\"}.glyphicon-paperclip:before{content:\"\uE142\"}.glyphicon-heart-empty:before{content:\"\uE143\"}.glyphicon-link:before{content:\"\uE144\"}.glyphicon-phone:before{content:\"\uE145\"}.glyphicon-pushpin:before{content:\"\uE146\"}.glyphicon-usd:before{content:\"\uE148\"}.glyphicon-gbp:before{content:\"\uE149\"}.glyphicon-sort:before{content:\"\uE150\"}.glyphicon-sort-by-alphabet:before{content:\"\uE151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\uE152\"}.glyphicon-sort-by-order:before{content:\"\uE153\"}.glyphicon-sort-by-order-alt:before{content:\"\uE154\"}.glyphicon-sort-by-attributes:before{content:\"\uE155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\uE156\"}.glyphicon-unchecked:before{content:\"\uE157\"}.glyphicon-expand:before{content:\"\uE158\"}.glyphicon-collapse-down:before{content:\"\uE159\"}.glyphicon-collapse-up:before{content:\"\uE160\"}.glyphicon-log-in:before{content:\"\uE161\"}.glyphicon-flash:before{content:\"\uE162\"}.glyphicon-log-out:before{content:\"\uE163\"}.glyphicon-new-window:before{content:\"\uE164\"}.glyphicon-record:before{content:\"\uE165\"}.glyphicon-save:before{content:\"\uE166\"}.glyphicon-open:before{content:\"\uE167\"}.glyphicon-saved:before{content:\"\uE168\"}.glyphicon-import:before{content:\"\uE169\"}.glyphicon-export:before{content:\"\uE170\"}.glyphicon-send:before{content:\"\uE171\"}.glyphicon-floppy-disk:before{content:\"\uE172\"}.glyphicon-floppy-saved:before{content:\"\uE173\"}.glyphicon-floppy-remove:before{content:\"\uE174\"}.glyphicon-floppy-save:before{content:\"\uE175\"}.glyphicon-floppy-open:before{content:\"\uE176\"}.glyphicon-credit-card:before{content:\"\uE177\"}.glyphicon-transfer:before{content:\"\uE178\"}.glyphicon-cutlery:before{content:\"\uE179\"}.glyphicon-header:before{content:\"\uE180\"}.glyphicon-compressed:before{content:\"\uE181\"}.glyphicon-earphone:before{content:\"\uE182\"}.glyphicon-phone-alt:before{content:\"\uE183\"}.glyphicon-tower:before{content:\"\uE184\"}.glyphicon-stats:before{content:\"\uE185\"}.glyphicon-sd-video:before{content:\"\uE186\"}.glyphicon-hd-video:before{content:\"\uE187\"}.glyphicon-subtitles:before{content:\"\uE188\"}.glyphicon-sound-stereo:before{content:\"\uE189\"}.glyphicon-sound-dolby:before{content:\"\uE190\"}.glyphicon-sound-5-1:before{content:\"\uE191\"}.glyphicon-sound-6-1:before{content:\"\uE192\"}.glyphicon-sound-7-1:before{content:\"\uE193\"}.glyphicon-copyright-mark:before{content:\"\uE194\"}.glyphicon-registration-mark:before{content:\"\uE195\"}.glyphicon-cloud-download:before{content:\"\uE197\"}.glyphicon-cloud-upload:before{content:\"\uE198\"}.glyphicon-tree-conifer:before{content:\"\uE199\"}.glyphicon-tree-deciduous:before{content:\"\uE200\"}.glyphicon-cd:before{content:\"\uE201\"}.glyphicon-save-file:before{content:\"\uE202\"}.glyphicon-open-file:before{content:\"\uE203\"}.glyphicon-level-up:before{content:\"\uE204\"}.glyphicon-copy:before{content:\"\uE205\"}.glyphicon-paste:before{content:\"\uE206\"}.glyphicon-alert:before{content:\"\uE209\"}.glyphicon-equalizer:before{content:\"\uE210\"}.glyphicon-king:before{content:\"\uE211\"}.glyphicon-queen:before{content:\"\uE212\"}.glyphicon-pawn:before{content:\"\uE213\"}.glyphicon-bishop:before{content:\"\uE214\"}.glyphicon-knight:before{content:\"\uE215\"}.glyphicon-baby-formula:before{content:\"\uE216\"}.glyphicon-tent:before{content:\"\u26FA\"}.glyphicon-blackboard:before{content:\"\uE218\"}.glyphicon-bed:before{content:\"\uE219\"}.glyphicon-apple:before{content:\"\uF8FF\"}.glyphicon-erase:before{content:\"\uE221\"}.glyphicon-hourglass:before{content:\"\u231B\"}.glyphicon-lamp:before{content:\"\uE223\"}.glyphicon-duplicate:before{content:\"\uE224\"}.glyphicon-piggy-bank:before{content:\"\uE225\"}.glyphicon-scissors:before{content:\"\uE226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\uE227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\u00A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\u20BD\"}.glyphicon-scale:before{content:\"\uE230\"}.glyphicon-ice-lolly:before{content:\"\uE231\"}.glyphicon-ice-lolly-tasted:before{content:\"\uE232\"}.glyphicon-education:before{content:\"\uE233\"}.glyphicon-option-horizontal:before{content:\"\uE234\"}.glyphicon-option-vertical:before{content:\"\uE235\"}.glyphicon-menu-hamburger:before{content:\"\uE236\"}.glyphicon-modal-window:before{content:\"\uE237\"}.glyphicon-oil:before{content:\"\uE238\"}.glyphicon-grain:before{content:\"\uE239\"}.glyphicon-sunglasses:before{content:\"\uE240\"}.glyphicon-text-size:before{content:\"\uE241\"}.glyphicon-text-color:before{content:\"\uE242\"}.glyphicon-text-background:before{content:\"\uE243\"}.glyphicon-object-align-top:before{content:\"\uE244\"}.glyphicon-object-align-bottom:before{content:\"\uE245\"}.glyphicon-object-align-horizontal:before{content:\"\uE246\"}.glyphicon-object-align-left:before{content:\"\uE247\"}.glyphicon-object-align-vertical:before{content:\"\uE248\"}.glyphicon-object-align-right:before{content:\"\uE249\"}.glyphicon-triangle-right:before{content:\"\uE250\"}.glyphicon-triangle-left:before{content:\"\uE251\"}.glyphicon-triangle-bottom:before{content:\"\uE252\"}.glyphicon-triangle-top:before{content:\"\uE253\"}.glyphicon-console:before{content:\"\uE254\"}.glyphicon-superscript:before{content:\"\uE255\"}.glyphicon-subscript:before{content:\"\uE256\"}.glyphicon-menu-left:before{content:\"\uE257\"}.glyphicon-menu-right:before{content:\"\uE258\"}.glyphicon-menu-down:before{content:\"\uE259\"}.glyphicon-menu-up:before{content:\"\uE260\"}.sel{font-size:.7rem;display:inline-block;margin:10px 0;width:120px;background-color:transparent;border-bottom:4px solid rgba(0,0,0,.3);position:relative;cursor:pointer}.sel.large{width:200px}.sel.xlarge{width:400px}.sel.auto{width:50%;min-width:200px}.sel::before{position:absolute;content:\"\uF063\";font-family:FontAwesome;font-size:2em;color:#1e9df8;right:20px;top:calc(50% - .5em)}.sel.active::before{transform:rotateX(-180deg)}.sel__placeholder{display:block;font-family:Quicksand;font-size:2.3em;color:#1e9df8;padding:.2em .5em;text-align:left;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;visibility:visible}.sel.active .sel__placeholder{visibility:hidden}.sel__placeholder::before{position:absolute;top:0;bottom:0;left:0;right:0;padding:.2em .5em;content:attr(data-placeholder);visibility:hidden}.sel.active .sel__placeholder::before{visibility:visible}.sel__box{position:absolute;top:calc(100% + 4px);left:-4px;display:none;list-style-type:none;text-align:left;font-size:1em;background-color:#fff;width:calc(100% + 8px);box-sizing:border-box}.sel.active .sel__box{display:block;-webkit-animation:.5s fadeInUp;animation:.5s fadeInUp}.sel__box__options{display:list-item;font-family:Quicksand;font-size:1.5em;color:#838e95;padding:.5em 1em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.sel__box__options.disabled{color:#63b175;font-size:1.1em;padding-top:10px;padding-bottom:10px;background-color:#e9e9e9;text-transform:uppercase;cursor:text}.sel__box__options.selected{color:#1e9df8}.sel__box__options::after{content:\"\uF00C\";font-family:FontAwesome;font-size:.5em;margin-left:5px;display:none}.sel__box__options.selected::after{display:inline}.sel__box__options:hover{background-color:#ebedef}@keyframes fadeInUp{from{opacity:0;transform:translate3d(0,20px,0)}to{opacity:1;transform:none}}@keyframes fadeOut{from{opacity:1}to{opacity:0}}.row:after{clear:both;content:\"\";display:block}.row .col{float:left}.row .col:not(:first-child){margin-left:1%!important}.row .col-md-3{width:24%}.row .col-md-4{width:32%}.row .col-md-6{width:49%}.row .col-md-8{width:64%}.row .col-md-9{width:74%}.row .col-md-12{width:100%;margin-left:0}.form-group .col{margin:8px 0}.card{color:#555;padding:20px 0;background-color:#fff;border-radius:5px}.card .card_img{width:100px;margin:0 auto}.card .card_content{margin-top:10px;padding:5px 20px;border-top:1px solid #e5e5e5}.card .card_content .card_line span{display:inline-block;padding:5px 0}.card .card_content .card_line span.key{width:30%;text-align:right;color:#999}.card .card_content .card_line span.value{width:calc(70% - 20px);text-align:left;padding-left:20px}*{margin:0;padding:0}body{color:#555;font-size:16px;font-family:\"EB Garamond\",serif;background-color:#f9f9f9}a{color:#335a9c;text-decoration:none}a:hover{text-decoration:underline}.container{width:90%;max-width:940px;min-width:340px;margin:0 auto}.clearfix{clear:both}.clickable{cursor:pointer}.page{padding:10px 0;background-color:#fff;box-shadow:0 1px 1px #ddd}.page>div{margin:0 30px}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert.alert-primary{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.btn{padding:9px 10px;color:#000;background-color:transparent;border:1px solid #999;border-radius:3px;cursor:pointer}.btn.btn-sm{font-size:70%;padding:3px 10px}.btn:hover{background-color:transparent}.btn.btn-danger{color:#fff;background-color:#c00000;border-color:#c00000}.btn.btn-danger:hover{color:#c00000;background-color:#fff}.btn.btn-primary{color:#fff;background-color:#335a9c;border-color:#335a9c}.btn.btn-primary:hover{color:#335a9c;background-color:#fff}.btn.btn-primary:disabled{color:#fff;background-color:rgba(51,90,156,.5);border-color:transparent}.btn.btn-success{color:#fff;background-color:#63b175;border-color:#63b175}.btn.btn-success:hover{color:#63b175;background-color:#fff}.btn.btn-success:disabled{color:#fff;background-color:rgba(99,177,117,.5);border-color:transparent}.btn.btn-secondary{color:#888;background-color:#f1f1f1;border-color:#c2c3c4}.btn.btn-secondary:hover{color:#888;background-color:#f9f9f9}.btn.btn-image{font-size:10px;padding:3px 8px 3px 1px;border-color:#335a9c;text-decoration:none}.btn.btn-image:hover{color:#335a9c;background-color:rgba(240,240,240,.9);text-decoration:none}.btn.btn-image i{display:inline-block;vertical-align:middle}.filter .sel:not(:first-child){margin-left:20px}.form label{display:block;margin-bottom:10px}.form label input,.form label textarea{width:calc(100% - 10px);display:block;margin-top:5px;padding:3px 5px;border:1px solid #ddd;border-radius:3px}.form label input{height:30px}.form label textarea{height:50px}.form button{padding:10px;color:#63b175;border:1px solid #335a9c;border-radius:3px;cursor:pointer}.form button:hover{color:#fff;background-color:#335a9c}.form .form-separator{color:#335a9c;font-size:80%;padding-bottom:5px;margin:30px 0 10px;text-transform:uppercase;border-bottom:1px solid #335a9c}.form-control:disabled{background-color:#eee;cursor:text}h3.title{font-size:30px;margin-bottom:20px}h3.title a{font-size:13px;margin-top:15px;display:inline-block;color:#335a9c;text-decoration:none;text-transform:uppercase}h3.title a:hover{text-decoration:underline}.hidden{display:none!important}.nowrap{white-space:nowrap}.pagination{text-align:right}.pagination a{color:#fff;margin:0 5px;padding:5px 15px;text-align:center;display:inline-block;background-color:#335a9c;cursor:pointer}.pagination a.active,.pagination a:hover{background-color:#335a9c}.pagination a.disabled{background-color:rgba(51,90,156,.5);text-decoration:none;cursor:text}.pull-right{float:right}.table{width:100%;border-collapse:collapse}.table td,.table th{padding:10px}.table thead th{text-align:left;border-bottom:1px solid #777}.table tbody tr:nth-child(odd) td{background-color:#f5f5f5}.table tbody tr:not(:first-child) td{border-top:1px solid #fff}.table tbody tr td.actions{width:100px;text-align:center}.table tbody tr td.actions.small{width:50px}.table tbody tr td.actions i{font-size:120%;display:inline-block;vertical-align:middle;cursor:pointer}.table tbody tr td.actions i:not(:first-child){margin-left:10px}.table tbody tr td.actions i:first-child{color:#63b175}.table tbody tr td.actions i:nth-child(2){color:#335a9c}.table tbody tr td.actions i:last-child{color:#c00000}.table tbody tr td.actions i:hover{color:#335a9c}.table tbody tr td img{width:20px;cursor:pointer}.table tbody tr td img:not(:first-child){margin-left:10px}.table tbody tr td img.avatar{width:30px}.table tbody tr td .story,.table tbody tr td a{color:#335a9c}.table tbody tr .text-small{font-size:11px}.table tfoot tr td{border-top:1px solid #777}.table.table-small td{padding-top:5px;padding-bottom:5px}.table.stripped tr:nth-child(odd) td{background-color:#fff}.table.stripped tr td:not(:first-child){border-left:1px solid #fff}.table.stripped tr td.icon-holder{text-align:center;vertical-align:middle}.table.stripped tr td.icon-holder .cash-icon{width:20px}.text-center{text-align:center!important}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-bold{font-weight:600}.text-blue{color:#335a9c!important}.text-gray{color:#888!important}.text-green{color:#63b175!important}.text-red{color:#c00000!important}.text-muted{color:#999}.text-small{font-size:80%}.text-uppercase{text-transform:uppercase}.text-no-break{white-space:nowrap}.text-ellipsis{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.modal{position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(0,0,0,.7)}.modal .modal-content{width:80%;max-width:500px;margin:20px auto;background-color:#fff;border-radius:3px}.modal .modal-content>*{padding:10px 20px}.modal .modal-content .modal-head{font-weight:700;color:#335a9c;text-transform:uppercase;border-bottom:1px solid #999}.modal .modal-content .modal-body{padding-top:20px}.modal .modal-content .modal-body .form-group label:not(:first-child){margin-top:0}.modal .modal-content .modal-body .btn-group{text-align:right}.btn-group{margin-top:20px}.btn-group .btn{display:inline-block;text-transform:uppercase}.btn-group .btn:not(.btn-sm){padding:6px 10px}.btn-group .btn:not(:first-child){margin-left:10px}.btn-group .btn.btn-cancel{color:#555;border-color:#ebedef}.btn-group .btn.btn-cancel:hover{color:#999;border-color:#999}.btn-group .btn.btn-apply{color:#fff;background-color:#63b175;border-color:#63b175}.btn-group .btn.btn-apply:hover{opacity:.6}.btn-group .btn.btn-apply:disabled{color:#555;background-color:#ebedef;border-color:#ebedef}.btn-group .btn.btn-delete{color:#fff;background-color:#c00000;border-color:#c00000}.btn-group .btn.btn-delete:hover{opacity:.6}.form-group label{display:block}.form-group label:not(:first-child){margin-top:10px}.form-group label[class^=col-].mgn-lt{margin-left:10px}.form-group label.labeled input{margin-top:5px}.form-group label>span{display:block;padding:5px 0;color:#555;text-transform:capitalize}.form-group label .radio span{padding:5px 10px;width:calc(49% - 22px);display:inline-block;text-align:center;border:1px solid #999;border-radius:3px;text-transform:capitalize;cursor:pointer}.form-group label .radio span:last-child{margin-left:2%}.form-group label .radio span:hover{color:#335a9c;border-color:#335a9c}.form-group label .radio span.active{color:#fff;background-color:#335a9c;border-color:#335a9c}.form-group .form-control{padding:8px 10px;width:calc(100% - 20px);border:1px solid #999;border-radius:3px}.form-group select.form-control{width:100%}.form-group select.form-control.no_fill{width:auto;min-width:100px}.form-group select.form-control.no_fill:not(:first-child){margin-left:10px}header{min-height:100px;position:relative;background-color:#fff}header .logo_holder{position:absolute;top:0;left:0;padding:20px 0 0 30px}header .logo_holder img{width:150px;display:block}header .logo_holder span{color:#335a9c;font-size:14px;text-transform:uppercase}header .content-user{position:absolute;top:30px;right:0;height:60px;background-color:#fff}header .content-user span{position:absolute;top:10px;right:80px;text-align:right;white-space:nowrap}header .content-user span a{color:#335a9c}header .content-user span small{display:block}header .content-user img{position:absolute;top:10px;right:30px;width:40px;height:40px}header nav{background-color:#394264}header nav a{width:90px;padding:7px 15px;margin-left:10px;margin-bottom:5px;text-align:center;display:inline-block;color:#fff;cursor:pointer;border-bottom:3px solid #fff}header nav a.active{border-color:#e64c65}header nav a:hover{border-color:#e64c65;color:#e64c65;text-decoration:none}header .sub-nav{background-color:#f1f1f1}header .sub-nav a{width:90px;margin-top:2px;margin-left:10px;margin-bottom:5px;padding:7px 15px;color:#777;text-align:center;display:inline-block;border-bottom:3px solid #777;cursor:pointer}header .sub-nav a:hover{color:#63b175;border-color:#63b175;text-decoration:none}header .sub-nav a.active{color:#e64c65;border-color:#e64c65}footer{margin:20px 30px;text-align:right}.bubble{padding:8px;display:inline-block;background-color:#f1f1f1;border-radius:8px}.bubble.green{background-color:#63b175}.bubble.red{background-color:#c00000}.sleek-chart .block{background-color:#394264;border-radius:5px;box-shadow:0 1px 1px 0;margin:0 20px 20px 0;width:100%}.sleek-chart .block.light-mode{background:#f3f3f3}.sleek-chart .block.light-mode .sleek-chart-legend div:not(.comparative),.sleek-chart .block.light-mode .sleek-chart-title{color:#394264}.sleek-chart .block.light-mode .sleek-chart-legend div:not(.comparative) span{background-color:#394264}.sleek-chart .block.light-mode .sleek-chart-draw #sleekChartLineDraw .line_container .line_container_item .hovered p:not(.comparative),.sleek-chart .block.light-mode .sleek-chart-draw #sleekChartLineDraw .line_container .line_container_item span{color:#394264}.sleek-chart .block.light-mode .sleek-chart-draw #sleekChartLineDraw .line_container .line_container_item span:not(.comparative){background-color:#394264}.sleek-chart .block.light-mode .sleek-chart-draw #sleekChartLineDraw .label_container span{color:#1f253d}.sleek-chart .block.light-mode .horizontal-list li{background-color:#e7e7e7;border-color:#c2c3c4}.sleek-chart .block.light-mode .horizontal-list li span{color:#394264}.sleek-chart .block.light-mode .horizontal-list li p.scnd-font-color{color:#1f253d}.sleek-chart .block.light-mode .horizontal-list li p.os-percentage,.sleek-chart .block.light-mode .sleek-chart-info{color:#394264}.sleek-chart{margin-bottom:20px}.sleek-chart .sleek-chart-title{color:#fff;font-size:1.4em;padding:30px 0 0;text-transform:uppercase}.sleek-chart .sleek-chart-legend{margin:5px 0 40px;padding:5px 0;background-color:rgba(0,0,0,.1)}.sleek-chart .sleek-chart-legend div{color:#fff;display:inline-block}.sleek-chart .sleek-chart-legend div span{width:20px;display:inline-block;padding:3px 1px;margin:0 5px 2px 0;background-color:#fff;border-radius:5px}.sleek-chart .sleek-chart-legend div.comparative{color:#777;margin-left:20px}.sleek-chart .sleek-chart-legend div.comparative span{background-color:#777}.sleek-chart .sleek-chart-draw{margin:20px 0 0;padding:0 20px}.sleek-chart .sleek-chart-draw #sleekChartLineDraw{margin:0 auto;min-width:400px}.sleek-chart .sleek-chart-draw #sleekChartLineDraw .line_container .line_container_item{display:inline-block;text-align:center;position:relative}.sleek-chart .sleek-chart-draw #sleekChartLineDraw .line_container .line_container_item:not(:first-child){margin-left:1px}.sleek-chart .sleek-chart-draw #sleekChartLineDraw .line_container .line_container_item .hovered{display:none;padding-bottom:10px;position:absolute;top:-40px;left:0;right:0}.sleek-chart .sleek-chart-draw #sleekChartLineDraw .line_container .line_container_item .hovered p{font-size:80%;color:#fff}.sleek-chart .sleek-chart-draw #sleekChartLineDraw .line_container .line_container_item .hovered p.comparative{color:#777}.sleek-chart .sleek-chart-draw #sleekChartLineDraw .line_container .line_container_item:hover .hovered{display:block}.sleek-chart .sleek-chart-draw #sleekChartLineDraw .line_container .line_container_item span{width:2px;display:inline-block;padding:0 2px;min-height:3px!important;background-color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.sleek-chart .sleek-chart-draw #sleekChartLineDraw .line_container .line_container_item span.comparative{margin-left:5px;background-color:#777}.sleek-chart .sleek-chart-draw #sleekChartLineDraw .label_container{color:#fff;padding-bottom:20px}.sleek-chart .sleek-chart-draw #sleekChartLineDraw .label_container span{color:#9099b7;display:inline-block;padding-top:5px;text-align:center;min-height:22px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.sleek-chart .sleek-chart-draw #sleekChartLineDraw .label_container span:not(:first-child){margin-left:1px}.sleek-chart .sleek-chart-info{color:#fff;padding-bottom:20px}"]
            }] }
];
/** @nocollapse */
ChartLineComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
ChartLineComponent.propDecorators = {
    title: [{ type: Input }],
    info: [{ type: Input }],
    data: [{ type: Input }],
    valueText: [{ type: Input }],
    comparativeValueText: [{ type: Input }],
    lightMode: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ChartLineComponent.prototype.title;
    /** @type {?} */
    ChartLineComponent.prototype.info;
    /** @type {?} */
    ChartLineComponent.prototype.data;
    /** @type {?} */
    ChartLineComponent.prototype.valueText;
    /** @type {?} */
    ChartLineComponent.prototype.comparativeValueText;
    /** @type {?} */
    ChartLineComponent.prototype.lightMode;
    /**
     * @type {?}
     * @private
     */
    ChartLineComponent.prototype.colors;
    /**
     * @type {?}
     * @private
     */
    ChartLineComponent.prototype.maxHeight;
    /**
     * @type {?}
     * @private
     */
    ChartLineComponent.prototype.maxValue;
    /**
     * @type {?}
     * @private
     */
    ChartLineComponent.prototype._cd;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/interceptor.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InterceptorService {
    /**
     * @param {?} _authService
     */
    constructor(_authService) {
        this._authService = _authService;
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    intercept(req, next) {
        if (req.url.endsWith('/sleek-team/auth')) {
            return next.handle(req);
        }
        /** @type {?} */
        const lastUpdateTime = this._authService.lastUpdateTime();
        /** @type {?} */
        const timeDiff = Date.now() - lastUpdateTime;
        /** @type {?} */
        const minuteInMs = 60000;
        if (timeDiff > (minuteInMs * 10)) {
            // refresh when last update older than 10 minutes
            this.refreshToken();
        }
        return next.handle(req);
    }
    /**
     * @private
     * @return {?}
     */
    refreshToken() {
        sessionStorage.setItem('token_update', String(Date.now()));
        this._authService.getPerson().then((/**
         * @return {?}
         */
        () => {
            console.debug('refreshing token.');
        }));
    }
}
InterceptorService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
InterceptorService.ctorParameters = () => [
    { type: AuthenticationService }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    InterceptorService.prototype._authService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/commons.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const COMPONENTS = [
    RootComponent,
    HeaderComponent,
    FooterComponent,
    AlertErrorComponent,
    AlertInfoComponent,
    AlertSuccessComponent,
    ButtonComponent,
    DropdownComponent,
    NavComponent,
    DatePickerComponent,
    PopupComponent,
    ChartDonutComponent,
    ChartLineComponent
];
class CommonsModule {
}
CommonsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [COMPONENTS, SortPipe],
                imports: [
                    BrowserModule,
                    FormsModule,
                    RouterModule,
                    HttpClientModule,
                    CommonModule,
                ],
                exports: [COMPONENTS, SortPipe],
                providers: [
                    {
                        provide: HTTP_INTERCEPTORS,
                        useClass: InterceptorService,
                        multi: true
                    }
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: commons.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { API_URL_AWS, API_URL_GCP, APP_URL_TEAM, AlertErrorComponent, AlertInfoComponent, AlertSuccessComponent, AuthenticationService, ButtonComponent, ButtonIcons, ChartDonutComponent, ChartLineComponent, Color, CommonsModule, CustomerService, DatePickerComponent, DateService, DropdownComponent, FileService, FooterComponent, HeaderComponent, NavComponent, PersonRoleService, PersonService, PopupComponent, ProjectService, RestService, RootComponent, SortPipe, VPS_TEST_URI, VPS_URI, InterceptorService as ɵa };
//# sourceMappingURL=commons.js.map
